import type { ConfigMap } from '@memorang/constants/config/schema';

export const customConstants: ConfigMap = {
  "jbjs": {
    "id": "jbjs",
    "tenant": {
      "id": "31da93b9-653e-44e9-94ff-b67a7ffd7012",
      "name": "JBJS"
    },
    "supportEmail": "support@mail.jbjs.org",
    "companyName": "JBJS",
    "app": {
      "id": "864cbe1b-be3e-43a5-a079-d7220aaf61a0",
      "name": "JBJS ACE",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "challenge.jbjs.memorang",
      "enableMediaPlayback": true,
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6480453242"
        },
        "android": {
          "versionCode": 8,
          "package": "com.memorang.jbjs.app",
          "googleServicesJson": "025a86be-33c1-448c-967d-86ac7e49d33e",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.jbjs",
          "buildNumberState": {
            "currentVersion": "1.0.10",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.11",
      "font": "opensans",
      "showDiagnostic": true,
      "purchase": {
        "isSubscriptionEnabled": true,
        "isPaywallEnabled": true,
        "paywall": {
          "title": "JBJS ACE Pro",
          "subtitle": "Unlock full access to every question, podcast, and performance insight"
        }
      },
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "analytics": {
        "mixpanel": {
          "id": "c4ccfdfa4bb14a8794546e96a01c1178"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_stacked_light.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/adaptive_icon.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_default_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/jbjs/logos/app_default_dark_new.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.jbjs.org",
        "privacy": "https://customersupport.jbjs.org/en-US/privacy-policy-136463",
        "tos": "https://customersupport.jbjs.org/en-US/jbjs-terms-of-use-136462",
        "redeemSupportUrl": "https://app.jbjs.org/legal/terms"
      },
      "keys": {
        "revenueCat": {
          "ios": "",
          "android": ""
        },
        "oneSignalAppId": "",
        "clerk": {
          "publishableKeyDev": "pk_test_c2ltcGxlLW1vbmFyY2gtMTIuY2xlcmsuYWNjb3VudHMuZGV2JA",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmpianMub3JnJA"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-jbjs-shared"
        }
      },
      "supportUrl": "https://jbjs.org/terms",
      "tagType": {
        "en-US": "Subspecialty"
      },
      "aiAssistant": {
        "title": "JBJS AI",
        "alias": "JBJS AI",
        "fabIcon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/jbjs/aila-fab-icon.svg",
        "icon": "https://memorang-prod-icon.s3.amazonaws.com/app-resources/jbjs/ios/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your AI Learning Assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for JBJS ACE"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official JBJS team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/ACME%20Mockup_light.webp"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 3,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": false
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_6iigTTJWgmWR3PsZkmK2UbtZ8N4P",
            "deployedAt": "2026-08-19T07:01:21.451Z",
            "version": "1.0.11"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": false,
      "quizEnabled": false,
      "allowChangeExam": false,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": false
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      }
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subspecialties",
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "study-pack-outline",
              "selected": "study-pack"
            },
            "enabled": false,
            "custom": true
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Library",
            "name": "(articles)/articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple-outline",
              "selected": "note-multiple"
            },
            "enabled": false
          },
          {
            "title": "CME",
            "name": "cme",
            "icon": {
              "default": "school-outline",
              "selected": "school"
            },
            "enabled": false
          },
          {
            "title": "Videos",
            "name": "videos",
            "icon": {
              "default": "video-outline",
              "selected": "video"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "google-podcast",
              "selected": "google-podcast"
            },
            "enabled": true
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "lightbulb-on-outline",
              "selected": "lightbulb-on"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "podium-gold",
              "selected": "podium"
            },
            "enabled": true
          },
          {
            "title": "Profile",
            "name": "profile",
            "icon": {
              "default": "account-outline",
              "selected": "account"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "testDriver": "default",
      "showFlightCalculator": false,
      "postAnswerStats": {
        "showXpEarned": false,
        "showNumAttempts": false
      },
      "allowMarking": true,
      "showCrossOut": false,
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(137, 147, 147)",
          "primary": "rgb(128, 212, 219)",
          "surface": "rgb(25, 28, 28)",
          "backdrop": "rgba(41, 50, 51, 0.4)",
          "tertiary": "rgb(196, 198, 203)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(28, 37, 38)",
            "level2": "rgb(29, 43, 44)",
            "level3": "rgb(31, 49, 50)",
            "level4": "rgb(31, 51, 52)",
            "level5": "rgb(32, 54, 56)"
          },
          "onPrimary": "rgb(0, 54, 58)",
          "onSurface": "rgb(224, 227, 227)",
          "secondary": "rgb(167, 207, 195)",
          "background": "rgb(11, 15, 15)",
          "onTertiary": "rgb(45, 49, 52)",
          "onSecondary": "rgb(16, 54, 46)",
          "onBackground": "rgb(224, 227, 227)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(0, 105, 112)",
          "inverseSurface": "rgb(224, 227, 227)",
          "outlineVariant": "rgb(63, 72, 73)",
          "surfaceVariant": "rgb(63, 72, 73)",
          "surfaceDisabled": "rgba(224, 227, 227, 0.12)",
          "inverseOnSurface": "rgb(45, 49, 49)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(190, 200, 201)",
          "primaryContainer": "rgb(0, 79, 84)",
          "onSurfaceDisabled": "rgba(224, 227, 227, 0.38)",
          "tertiaryContainer": "rgb(68, 71, 75)",
          "onPrimaryContainer": "rgb(156, 240, 248)",
          "secondaryContainer": "rgb(41, 77, 68)",
          "onTertiaryContainer": "rgb(225, 226, 231)",
          "onSecondaryContainer": "rgb(195, 235, 222)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(111, 121, 122)",
          "primary": "rgb(0, 113, 120)",
          "surface": "rgb(250, 253, 252)",
          "backdrop": "rgba(41, 50, 51, 0.4)",
          "tertiary": "rgb(83, 86, 90)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 246, 245)",
            "level2": "rgb(230, 241, 241)",
            "level3": "rgb(223, 237, 237)",
            "level4": "rgb(220, 235, 235)",
            "level5": "rgb(215, 232, 232)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(25, 28, 28)",
          "secondary": "rgb(115, 153, 142)",
          "background": "rgb(239, 241, 241)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(25, 28, 28)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(77, 217, 228)",
          "inverseSurface": "rgb(45, 49, 49)",
          "outlineVariant": "rgb(190, 200, 201)",
          "surfaceVariant": "rgb(218, 228, 229)",
          "surfaceDisabled": "rgba(25, 28, 28, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 241)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(63, 72, 73)",
          "primaryContainer": "rgb(156, 240, 248)",
          "onSurfaceDisabled": "rgba(25, 28, 28, 0.38)",
          "tertiaryContainer": "rgb(225, 226, 231)",
          "onPrimaryContainer": "rgb(0, 32, 34)",
          "secondaryContainer": "rgb(195, 235, 222)",
          "onTertiaryContainer": "rgb(25, 28, 31)",
          "onSecondaryContainer": "rgb(0, 32, 26)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-19 10:56:25.353426+00"
  },
  "wocncb": {
    "id": "wocncb",
    "tenant": {
      "id": "4c80ce98-ef6c-41c8-ab54-f4db19c75136",
      "name": "WOCNCB"
    },
    "supportEmail": "info@wocncb.org",
    "companyName": "PSI",
    "app": {
      "id": "3dc9d834-de55-4863-b55b-dc155b1772f1",
      "name": "WOCNCB",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "wocncb.memorang",
      "mobile": {
        "apple": {
          "teamId": "BC53J54M4K",
          "ascIssuerId": "69f6e117-aacb-485b-ba74-a8f7e2551649",
          "ascKeyId": "W4K53B5C68",
          "ascApiKeyP8": "62f548b6-6866-4cd3-89e1-6123adf48e99",
          "ascAppId": "6751701252"
        },
        "android": {
          "versionCode": 9,
          "package": "com.memorang.psi.wocncb",
          "googleServicesJson": "e00323a3-fa9b-405e-98c2-7beab336d046",
          "serviceAccountJson": "63c77907-0fe6-4fc5-901c-d35ba6c91753"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.wocncb.testprep",
          "buildNumberState": {
            "currentVersion": "1.0.19",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.23",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "opensans",
      "trademark": "PSI",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "231157f1f863de509dee703a59a7eae2"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon_new.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon_new.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_logo_stacked_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_logo_stacked_dark_new.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark_new.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.wocncb.org",
        "privacy": "https://app.wocncb.org/legal/privacy",
        "tos": "https://app.wocncb.org/legal/terms",
        "ios": "https://apps.apple.com/tn/app/wocncb-practice-exam-tool/id6751701252",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.wocncb&hl",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.wocncb.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_AjPruGvspvUXzefpAWxOIHvjvPD",
          "android": "goog_HAXzINaGLxSfBduzHQAFiJHysEZ"
        },
        "oneSignalAppId": "92935195-1416-45d0-8318-57659142569b",
        "clerk": {
          "publishableKeyDev": "pk_test_Y29tcGxldGUtbWVlcmthdC02NS5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLndvY25jYi5vcmck"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "WOCNCB AI",
        "alias": "WOCNCB AI",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your AI Learning Assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "Test Prep app for WOCNCB"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "Authored by the wocncb team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/landing.webp"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "contentStatusFilters": {
          "visibleStatuses": [
            "PUBLISHED"
          ]
        },
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": false
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_7BMFJ6NVy4fapX5MvoUksB7jKdqM",
            "deployedAt": "2026-08-14T07:08:55.804Z",
            "version": "1.0.23"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery",
      "showRedeem": true,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "isMobile": true,
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "How we protect and use your data"
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "icon": "shield-check-outline"
          },
          {
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "icon": "lock-outline"
          },
          {
            "titlei18n": {
              "en-US": "You control your data"
            },
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "icon": "account-cog-outline"
          },
          {
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam"
        },
        "descriptioni18n": {
          "en-US": "Select the certification exam you are preparing for."
        }
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam Date"
        },
        "descriptioni18n": {
          "en-US": "We will build your study plan around your exam date."
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(148, 143, 153)",
          "primary": "rgb(211, 187, 255)",
          "surface": "rgb(29, 27, 30)",
          "backdrop": "rgba(50, 47, 55, 0.4)",
          "tertiary": "rgb(240, 183, 197)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(38, 35, 41)",
            "level2": "rgb(44, 40, 48)",
            "level3": "rgb(49, 45, 55)",
            "level4": "rgb(51, 46, 57)",
            "level5": "rgb(54, 49, 62)"
          },
          "onPrimary": "rgb(60, 29, 113)",
          "onSurface": "rgb(230, 225, 230)",
          "secondary": "rgb(255, 184, 107)",
          "background": "rgb(15, 13, 19)",
          "onTertiary": "rgb(74, 37, 48)",
          "onSecondary": "rgb(73, 41, 0)",
          "onBackground": "rgb(230, 225, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(107, 78, 162)",
          "inverseSurface": "rgb(230, 225, 230)",
          "outlineVariant": "rgb(73, 69, 78)",
          "surfaceVariant": "rgb(73, 69, 78)",
          "surfaceDisabled": "rgba(230, 225, 230, 0.12)",
          "inverseOnSurface": "rgb(50, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(203, 196, 207)",
          "primaryContainer": "rgb(83, 54, 136)",
          "onSurfaceDisabled": "rgba(230, 225, 230, 0.38)",
          "tertiaryContainer": "rgb(100, 59, 70)",
          "onPrimaryContainer": "rgb(235, 221, 255)",
          "secondaryContainer": "rgb(104, 61, 0)",
          "onTertiaryContainer": "rgb(255, 217, 225)",
          "onSecondaryContainer": "rgb(255, 220, 188)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(122, 117, 127)",
          "primary": "rgb(107, 78, 162)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(50, 47, 55, 0.4)",
          "tertiary": "rgb(127, 82, 93)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(248, 242, 250)",
            "level2": "rgb(243, 237, 248)",
            "level3": "rgb(239, 232, 245)",
            "level4": "rgb(237, 230, 244)",
            "level5": "rgb(234, 227, 242)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(29, 27, 30)",
          "secondary": "rgb(137, 81, 0)",
          "background": "rgb(245, 239, 244)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(29, 27, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(211, 187, 255)",
          "inverseSurface": "rgb(50, 48, 51)",
          "outlineVariant": "rgb(203, 196, 207)",
          "surfaceVariant": "rgb(231, 224, 235)",
          "surfaceDisabled": "rgba(29, 27, 30, 0.12)",
          "inverseOnSurface": "rgb(245, 239, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(73, 69, 78)",
          "primaryContainer": "rgb(235, 221, 255)",
          "onSurfaceDisabled": "rgba(29, 27, 30, 0.38)",
          "tertiaryContainer": "rgb(255, 217, 225)",
          "onPrimaryContainer": "rgb(38, 0, 89)",
          "secondaryContainer": "rgb(255, 220, 188)",
          "onTertiaryContainer": "rgb(49, 16, 27)",
          "onSecondaryContainer": "rgb(44, 23, 0)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-14 07:08:55.865714+00"
  },
  "therapyed": {
    "id": "therapyed",
    "tenant": {
      "id": "53d94851-4af6-4dfc-943d-92929b3e9dcc",
      "name": "TherapyEd"
    },
    "supportEmail": "info@therapyed.com",
    "companyName": "TherapyEd",
    "app": {
      "id": "db878dfd-9617-456b-b458-14902e06462f",
      "name": "TherapyEd",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "therapyed.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1590041414"
        },
        "android": {
          "versionCode": 105,
          "package": "com.memorang.therapyed",
          "googleServicesJson": "73a57898-161a-4aa1-837f-e0ba27222a26",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.therapyed",
          "buildNumberState": {
            "currentVersion": "2.1.40",
            "buildNumber": 2
          }
        }
      },
      "version": "2.1.43",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "https://apps.apple.com/us/app/therapyed/id1590041414",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.therapyed"
        },
        "subtitle": "We are currently making improvements to enhance your experience. TherapyEd app will be down for maintenance from 12:30AM-6:30AM PT / 3:30AM-9:30AM ET. We apologize for any inconvenience and appreciate your patience. After the maintenance, the current version of the app will be deprecated. Please update the app from the App Store or Play Store to continue using it."
      },
      "font": "opensans",
      "trademark": "TherapyEd",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "5b3fe7e0378f1a1bd87bc085ddc9b66e"
        }
      },
      "logo": {
        "icon": "https://icon.memorang.com/app-resources/therapyed/ios/icon.png",
        "adaptiveIcon": "https://icon.memorang.com/app-resources/therapyed/android/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.therapyed.com",
        "privacy": "https://app.therapyed.com/legal/privacy",
        "tos": "https://app.therapyed.com/legal/terms",
        "redeemSupportUrl": "https://therapyed.zendesk.com/hc/en-us/articles/6864418376468-How-can-I-redeem-access-to-my-purchased-content-",
        "companyUrl": "https://www.therapyed.com/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_LCnNlSXwMCLCGLQsftcakAoejTs",
          "android": "goog_cFBRaPbCakxtxjBbmsUDprlTzfN"
        },
        "oneSignalAppId": "ac799c9b-47da-4692-b722-ce25feffc4ca",
        "clerk": {
          "publishableKeyDev": "pk_test_ZnJlZS1sZW9wYXJkLTExLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnRoZXJhcHllZC5jb20k"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-therapyed-shared"
        }
      },
      "supportUrl": "https://therapyed.zendesk.com/hc/en-us",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "TherapyEd AI",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/icons/therapyed/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning agent, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TherapyEd Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TherapyEd team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/therapyed/therapyed/aibl/landing_graphic.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "crossTagSelection": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_Dx1AQJewDzRAek94pRRZPtKsNSTf",
            "deployedAt": "2026-08-20T07:54:20.888Z",
            "version": "2.1.43"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      }
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domains",
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "isMobile": true,
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "icon": "shield-check-outline"
          },
          {
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "icon": "lock-outline"
          },
          {
            "titlei18n": {
              "en-US": "You control your data"
            },
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "icon": "account-cog-outline"
          },
          {
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam"
        }
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam Date"
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "enableSessionReplay": false,
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(140, 145, 153)",
          "primary": "rgb(255, 180, 163)",
          "surface": "rgb(40, 42, 44)",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(214, 190, 228)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(51, 49, 50)",
            "level2": "rgb(57, 53, 54)",
            "level3": "rgb(64, 57, 57)",
            "level4": "rgb(66, 59, 58)",
            "level5": "rgb(70, 61, 61)"
          },
          "onPrimary": "rgb(99, 16, 0)",
          "onSurface": "rgb(226, 226, 230)",
          "secondary": "rgb(157, 202, 255)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(58, 42, 72)",
          "onSecondary": "rgb(0, 50, 87)",
          "onBackground": "rgb(226, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(171, 53, 26)",
          "inverseSurface": "rgb(226, 226, 230)",
          "outlineVariant": "rgb(66, 71, 78)",
          "surfaceVariant": "rgb(66, 71, 78)",
          "surfaceDisabled": "rgba(226, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(194, 199, 207)",
          "primaryContainer": "rgb(137, 29, 3)",
          "onSurfaceDisabled": "rgba(226, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(82, 64, 95)",
          "onPrimaryContainer": "rgb(255, 218, 210)",
          "secondaryContainer": "rgb(0, 73, 123)",
          "onTertiaryContainer": "rgb(242, 218, 255)",
          "onSecondaryContainer": "rgb(208, 228, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(133, 115, 111)",
          "primary": "#ab351a",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(59, 45, 42, 0.4)",
          "tertiary": "rgb(106, 87, 120)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(255, 255, 255)",
            "level2": "rgb(255, 255, 255)",
            "level3": "rgb(255, 255, 255)",
            "level4": "rgb(255, 255, 255)",
            "level5": "rgb(255, 255, 255)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(32, 26, 25)",
          "secondary": "rgb(0, 98, 162)",
          "background": "#f2f2f2",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(32, 26, 25)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(255, 180, 163)",
          "inverseSurface": "rgb(54, 47, 45)",
          "outlineVariant": "rgb(216, 194, 189)",
          "surfaceVariant": "rgb(245, 221, 216)",
          "surfaceDisabled": "rgba(32, 26, 25, 0.12)",
          "inverseOnSurface": "rgb(251, 238, 235)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(83, 67, 64)",
          "primaryContainer": "rgb(255, 218, 210)",
          "onSurfaceDisabled": "rgba(32, 26, 25, 0.38)",
          "tertiaryContainer": "rgb(242, 218, 255)",
          "onPrimaryContainer": "rgb(61, 6, 0)",
          "secondaryContainer": "rgb(209, 228, 255)",
          "onTertiaryContainer": "rgb(37, 20, 50)",
          "onSecondaryContainer": "rgb(0, 29, 53)"
        }
      },
      "roundness": 4
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 07:54:20.925546+00"
  },
  "aavsb": {
    "id": "aavsb",
    "tenant": {
      "id": "36b05d62-872c-404b-9c62-c42a9c5434b8",
      "name": "AAVSB"
    },
    "supportEmail": "info@aavsb.com",
    "companyName": "PSI",
    "app": {
      "id": "86cc8809-4824-4c22-a0f7-88246b597afb",
      "name": "AAVSB",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "aavsb.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6749604020"
        },
        "android": {
          "versionCode": 11,
          "package": "com.memorang.aavsb",
          "googleServicesJson": "b73becbb-6271-4a11-a3e8-2016a479b84a",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.aavsb",
          "buildNumberState": {
            "currentVersion": "1.0.22",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.22",
      "font": "sourcesanspro",
      "trademark": "AAVSB",
      "showDiagnostic": false,
      "showPracticeTests": false,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "c8f990c7eda09ea22a741fd54ff3fde8"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.aavsb.org",
        "privacy": "https://app.aavsb.org/legal/privacy",
        "tos": "https://app.aavsb.org/legal/terms",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.aavsb.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_RiYIviJZZyKVQNLjkzWJQpitxYU",
          "android": "goog_ukzQuWRLGPOokJXXVWhTwETvDRz"
        },
        "oneSignalAppId": "236a14f3-9b96-4664-957c-a44b24fcd7f0",
        "clerk": {
          "publishableKeyDev": "pk_test_c2luY2VyZS1maWxseS0yMy5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmFhdnNiLm9yZyQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AI Study Pawtner",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/assistant_icon_light.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for AAVSB Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official AAVSB team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/landing_graphic.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_Fqut1af9ZyetoVK6cR9EEGPtyMLu",
            "deployedAt": "2026-05-07T16:09:04.460Z",
            "version": "1.0.22"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Assessments",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": false
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration. Looking to schedule/reschedule your official exam? [**Click here**](https://www.aavsb.org/students-exams/veterinary-technician-national-exam/applying-to-take-the-vtne/)"
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery",
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Home",
            "name": "study-pack",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(142, 144, 153)",
          "primary": "rgb(172, 199, 255)",
          "surface": "rgb(27, 27, 31)",
          "backdrop": "rgba(45, 48, 56, 0.4)",
          "tertiary": "rgb(221, 188, 224)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(34, 36, 42)",
            "level2": "rgb(39, 41, 49)",
            "level3": "rgb(43, 46, 56)",
            "level4": "rgb(44, 48, 58)",
            "level5": "rgb(47, 51, 62)"
          },
          "onPrimary": "rgb(0, 47, 103)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(255, 176, 206)",
          "background": "rgb(13, 14, 17)",
          "onTertiary": "rgb(63, 40, 68)",
          "onSecondary": "rgb(99, 0, 58)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(46, 93, 168)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(68, 71, 78)",
          "surfaceVariant": "rgb(68, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(196, 198, 208)",
          "primaryContainer": "rgb(8, 69, 143)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(87, 62, 92)",
          "onPrimaryContainer": "rgb(215, 226, 255)",
          "secondaryContainer": "rgb(140, 0, 84)",
          "onTertiaryContainer": "rgb(250, 215, 253)",
          "onSecondaryContainer": "rgb(255, 217, 229)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(116, 119, 127)",
          "primary": "rgb(46, 93, 168)",
          "surface": "rgb(254, 251, 255)",
          "backdrop": "rgba(45, 48, 56, 0.4)",
          "tertiary": "rgb(112, 85, 116)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(244, 243, 251)",
            "level2": "rgb(237, 238, 248)",
            "level3": "rgb(231, 234, 245)",
            "level4": "rgb(229, 232, 245)",
            "level5": "rgb(225, 229, 243)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(27, 27, 31)",
          "secondary": "rgb(173, 35, 109)",
          "background": "rgb(242, 240, 244)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(27, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(172, 199, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(196, 198, 208)",
          "surfaceVariant": "rgb(224, 226, 236)",
          "surfaceDisabled": "rgba(27, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(242, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(68, 71, 78)",
          "primaryContainer": "rgb(215, 226, 255)",
          "onSurfaceDisabled": "rgba(27, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(250, 215, 253)",
          "onPrimaryContainer": "rgb(0, 26, 64)",
          "secondaryContainer": "rgb(255, 217, 229)",
          "onTertiaryContainer": "rgb(41, 19, 46)",
          "onSecondaryContainer": "rgb(62, 0, 34)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 13:44:49.28354+00"
  },
  "wpi": {
    "id": "wpi",
    "tenant": {
      "id": "1977bda2-690e-434a-a046-bd0e06b55aa7",
      "name": "WPI"
    },
    "supportEmail": "support@app.gowpi.org",
    "companyName": "WPI",
    "app": {
      "id": "5789d9fc-0af8-4061-a5d5-7ae256a6be8c",
      "name": "WPI Exam Prep",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "wpi.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6754835308"
        },
        "android": {
          "versionCode": 5,
          "package": "com.memorang.psi.wpi",
          "googleServicesJson": "292d2e6d-f01c-4408-aef2-2cc674184d08",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.wpi",
          "buildNumberState": {
            "currentVersion": "1.0.20",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.20",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "notoserif",
      "trademark": "PSI",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "purchase": {
        "isPaywallEnabled": true
      },
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "0451a8941c04c763a14b8503d35b062c"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/icon_new.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/icon_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/app_logo_default.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/app_logo_default_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.gowpi.org",
        "privacy": "https://app.gowpi.org/legal/privacy",
        "tos": "https://app.gowpi.org/legal/terms",
        "ios": "https://apps.apple.com/az/app/wpi-exam-prep/id6754835308",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.wpi&hl=en_IN",
        "companyUrl": "https://www.gowpi.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_xpDPjERhWxDwqMJlfzqvuclSDqs",
          "android": "goog_SJlKLukyjmahxmJtUdUAaCsPsZr"
        },
        "oneSignalAppId": "8145f29b-0446-4778-9206-da48bb5bdbf0",
        "clerk": {
          "publishableKeyDev": "pk_test_Y29tcGxldGUtbWVlcmthdC02NS5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmdvd3BpLm9yZyQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "AI Learning Agent",
        "alias": "Q",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/wpi/assets/icons/icon.png",
        "showOriginalQuestion": false,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": false,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for WPI"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official WPI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": false
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_Fqut1af9ZyetoVK6cR9EEGPtyMLu",
            "deployedAt": "2026-05-07T16:09:04.403Z",
            "version": "1.0.20"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery",
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "isMobile": true,
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "How we protect and use your data"
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "icon": "shield-check-outline"
          },
          {
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "icon": "lock-outline"
          },
          {
            "titlei18n": {
              "en-US": "You control your data"
            },
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "icon": "account-cog-outline"
          },
          {
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam"
        },
        "descriptioni18n": {
          "en-US": "Select the certification exam you are preparing for."
        }
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam Date"
        },
        "descriptioni18n": {
          "en-US": "We will build your study plan around your exam date."
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Library",
            "name": "(articles)/articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(145, 144, 154)",
          "primary": "rgb(189, 194, 255)",
          "surface": "rgb(27, 27, 31)",
          "backdrop": "rgba(48, 48, 56, 0.4)",
          "tertiary": "rgb(232, 185, 213)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(35, 35, 42)",
            "level2": "rgb(40, 40, 49)",
            "level3": "rgb(45, 45, 56)",
            "level4": "rgb(46, 47, 58)",
            "level5": "rgb(50, 50, 62)"
          },
          "onPrimary": "rgb(3, 18, 160)",
          "onSurface": "rgb(228, 225, 230)",
          "secondary": "rgb(133, 210, 224)",
          "background": "rgb(14, 14, 17)",
          "onTertiary": "rgb(69, 38, 60)",
          "onSecondary": "rgb(0, 54, 61)",
          "onBackground": "rgb(228, 225, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(67, 79, 205)",
          "inverseSurface": "rgb(228, 225, 230)",
          "outlineVariant": "rgb(70, 70, 79)",
          "surfaceVariant": "rgb(70, 70, 79)",
          "surfaceDisabled": "rgba(228, 225, 230, 0.12)",
          "inverseOnSurface": "rgb(48, 48, 52)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(199, 197, 208)",
          "primaryContainer": "rgb(40, 52, 181)",
          "onSurfaceDisabled": "rgba(228, 225, 230, 0.38)",
          "tertiaryContainer": "rgb(94, 60, 83)",
          "onPrimaryContainer": "rgb(224, 224, 255)",
          "secondaryContainer": "rgb(0, 79, 88)",
          "onTertiaryContainer": "rgb(255, 216, 238)",
          "onSecondaryContainer": "rgb(162, 239, 253)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(119, 118, 128)",
          "primary": "rgb(67, 79, 205)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(48, 48, 56, 0.4)",
          "tertiary": "rgb(120, 83, 107)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(246, 242, 253)",
            "level2": "rgb(240, 237, 251)",
            "level3": "rgb(234, 232, 250)",
            "level4": "rgb(232, 230, 249)",
            "level5": "rgb(229, 227, 248)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(27, 27, 31)",
          "secondary": "rgb(0, 104, 116)",
          "background": "rgb(243, 240, 244)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(27, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(189, 194, 255)",
          "inverseSurface": "rgb(48, 48, 52)",
          "outlineVariant": "rgb(199, 197, 208)",
          "surfaceVariant": "rgb(227, 225, 236)",
          "surfaceDisabled": "rgba(27, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(243, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(70, 70, 79)",
          "primaryContainer": "rgb(224, 224, 255)",
          "onSurfaceDisabled": "rgba(27, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(255, 216, 238)",
          "onPrimaryContainer": "rgb(0, 6, 104)",
          "secondaryContainer": "rgb(162, 239, 253)",
          "onTertiaryContainer": "rgb(46, 17, 38)",
          "onSecondaryContainer": "rgb(0, 31, 36)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 12:04:37.64892+00"
  },
  "toeic": {
    "id": "toeic",
    "tenant": {
      "id": "a4c3e535-1a3b-4913-9b90-a68c203b7b3a",
      "name": "TOEIC Link Prep"
    },
    "supportEmail": "support@toeic.com",
    "companyName": "ETS",
    "app": {
      "id": "c8f4ca13-2364-4a4b-aab5-6751666186d7",
      "name": "TOEIC Link Prep",
      "template": "language-learning",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "toeiclink.memorang",
      "mobile": {
        "apple": {
          "teamId": "WGC236CZU9",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6761478656"
        },
        "android": {
          "versionCode": 26,
          "package": "org.ets.toeic_link_prep",
          "googleServicesJson": "d480a243-b2a4-4f5b-863c-a55fa2a191d5",
          "serviceAccountJson": ""
        },
        "ios": {
          "bundleIdentifier": "org.ets.toeic-link-prep",
          "buildNumberState": {
            "currentVersion": "1.0.45",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.71",
      "font": "opensans",
      "trademark": "TOEIC",
      "showDiagnostic": false,
      "showPracticeTests": false,
      "purchase": {
        "isPaywallEnabled": false
      },
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              79
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "proficiencyLevels": [
        {
          "id": "37011",
          "darkColor": "#d66565",
          "lightColor": "#FFDAD8",
          "sortOrder": 1,
          "icon": "toeic-basic",
          "range": {
            "type": "percentage",
            "score": [
              0,
              33
            ],
            "points": [
              0,
              33
            ]
          },
          "alias": {
            "title": "Basic"
          },
          "level": "basic"
        },
        {
          "id": "37012",
          "darkColor": "#dda53a",
          "lightColor": "#FFE4B2",
          "sortOrder": 2,
          "icon": "toeic-intermediate",
          "range": {
            "type": "percentage",
            "score": [
              33,
              66
            ],
            "points": [
              33,
              66
            ]
          },
          "alias": {
            "title": "Intermediate"
          },
          "level": "intermediate"
        },
        {
          "id": "37013",
          "darkColor": "#66bb68",
          "lightColor": "#BBF0B5",
          "sortOrder": 3,
          "icon": "toeic-advanced",
          "range": {
            "type": "percentage",
            "score": [
              66,
              100
            ],
            "points": [
              66,
              100
            ]
          },
          "alias": {
            "title": "Proficient"
          },
          "level": "proficient"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": true,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "955aaa7f64a5120faa49360d55b3bcab"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/icon.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/app_logo_default_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/app_logo_default_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://prep.toeiclink.com",
        "privacy": "https://www.ets.org/legal/privacy.html",
        "tos": "https://www.ets.org/legal/terms.html",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.ets.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_IxjnMCsBzrihpPpnjxQdIKoCOnR",
          "android": "goog_eXgRGhiVhrUgNmKeaMkaLOFuLdC"
        },
        "oneSignalAppId": "17f9c67c-1662-4d12-aa42-3ce85035f252",
        "clerk": {
          "publishableKeyDev": "pk_test_dXNlZnVsLWJ1bGxkb2ctMjEuY2xlcmsuYWNjb3VudHMuZGV2JA",
          "publishableKeyProd": "pk_live_Y2xlcmsucHJlcC50b2VpY2xpbmsuY29tJA"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "AI Learning Assistant",
        "alias": "Link AI",
        "fabIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/aila_fab_icon.png",
        "fabDarkIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/aila_fab_icon_dark.png",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/aila_icon.png",
        "darkIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/icons/aila_icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TOEIC Link Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TOEIC Link team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/toeic/images/landing.png",
        "consent": {
          "text": {
            "en-US": "By continuing, I agree to [ETS' Privacy Policy](https://www.ets.org/legal/privacy.html) and [Terms of Service](https://www.ets.org/legal/terms.html)"
          }
        }
      },
      "showCountrySelection": false,
      "avatarType": "glass",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": false,
        "showDurationSelection": true,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": true
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showLanguageSettings": true,
        "showAudioTestDialog": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_7Xy5rFmK4HKcyz8NDcHM5uxtLs5U",
            "deployedAt": "2026-08-20T06:56:30.417Z",
            "version": "1.0.71"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US",
          "fr-FR",
          "es-MX",
          "id-ID",
          "pt-BR",
          "vi-VN",
          "ms-MY",
          "tr-TR"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Diagnostics",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration. Looking to schedule/reschedule your official exam? [**Click here**](https://www.ets.org/toeic/test-takers.html)"
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Skills",
      "showRedeem": true,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "scaled",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery",
            "ja-JP": "推定習熟度",
            "zh-CN": "估计掌握度"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Performance",
            "ja-JP": "パフォーマンス",
            "zh-CN": "表现"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": true,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": true
      },
      "formative": {
        "showPointsBasedScore": false,
        "maxScore": 25,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "welcome",
        "enabled": true,
        "titlei18n": {
          "en-US": "Welcome to the official TOEIC Link Prep app"
        },
        "descriptioni18n": {
          "en-US": "Answer a few quick questions so we can personalize your TOEIC Link study plan and recommendations."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Takes just 60 seconds"
            },
            "icon": "clock-outline"
          },
          {
            "titlei18n": {
              "en-US": "Tailored to your goals"
            },
            "icon": "chart-box-outline"
          },
          {
            "titlei18n": {
              "en-US": "Your data stays protected"
            },
            "icon": "account-circle-outline"
          }
        ]
      },
      {
        "step": "profile",
        "enabled": true,
        "titlei18n": {
          "en-US": "What should we call you?"
        },
        "labeli18n": {
          "en-US": "Profile"
        },
        "descriptioni18n": {
          "en-US": "Your name and avatar appear on your dashboard, reports, and leaderboard."
        }
      },
      {
        "step": "learnerType",
        "enabled": true,
        "titlei18n": {
          "en-US": "What best describes you?"
        },
        "labeli18n": {
          "en-US": "Learner type"
        },
        "descriptioni18n": {
          "en-US": "We’ll use this to guide you to the best starting point."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "First-time test taker"
            },
            "descriptioni18n": {
              "en-US": "I haven't taken TOEIC Link before"
            },
            "icon": "bullseye-arrow",
            "type": "first-time"
          },
          {
            "titlei18n": {
              "en-US": "Retaking the exam"
            },
            "descriptioni18n": {
              "en-US": "I want to improve my previous score"
            },
            "icon": "refresh",
            "type": "retaking"
          },
          {
            "titlei18n": {
              "en-US": "Just exploring"
            },
            "descriptioni18n": {
              "en-US": "I'm curious about this exam"
            },
            "icon": "file-search-outline",
            "type": "exploring"
          }
        ]
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "When is your TOEIC Link exam?"
        },
        "labeli18n": {
          "en-US": "Exam date"
        },
        "descriptioni18n": {
          "en-US": "The closer your exam date, the more focused your study plan will be."
        }
      },
      {
        "step": "plan",
        "enabled": true,
        "titlei18n": {
          "en-US": "How much time can you devote to studying each day?"
        },
        "labeli18n": {
          "en-US": "Study plan"
        },
        "descriptioni18n": {
          "en-US": "We'll personalize your study recommendations based on your exam date and daily study time."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "30 minutes"
            },
            "icon": "clock-fast",
            "type": "30"
          },
          {
            "titlei18n": {
              "en-US": "60 minutes"
            },
            "icon": "clock-star-four-points-outline",
            "type": "60"
          },
          {
            "titlei18n": {
              "en-US": "90 minutes"
            },
            "icon": "book-open-blank-variant",
            "type": "90"
          },
          {
            "titlei18n": {
              "en-US": "120 minutes"
            },
            "icon": "book-open-page-variant",
            "type": "120"
          }
        ]
      },
      {
        "step": "toeicLevelOverview",
        "enabled": true,
        "titlei18n": {
          "en-US": "Level overview"
        },
        "labeli18n": {
          "en-US": "Levels"
        }
      },
      {
        "step": "review",
        "enabled": true,
        "titlei18n": {
          "en-US": "Your personalized study plan is ready."
        },
        "labeli18n": {
          "en-US": "Profile ready"
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Home",
            "name": "study-pack",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "CME",
            "name": "cme",
            "icon": {
              "default": "certificate-outline",
              "selected": "certificate"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": true
    },
    "sessionView": {
      "cta": "Study Now",
      "welcomeDialog": {
        "diagnostic": {
          "title": "Diagnostic Test: {{skill}}",
          "body": "Welcome to the **{{skill}} Diagnostic Test**. This **TIMED** assessment mimics an actual **TOEIC Link** experience.\n\nYour results will help us understand your current skill level, identify your strengths and weaknesses, and create an adaptive learning journey for you.\n\n**Before you begin:**\n\n- **Total test time: {{min}} minutes**\n{{skillInstructions}}\n- **This test can only be taken once.**\n\nGood luck!",
          "skillVariables": {
            "skill": {
              "reading": "Reading",
              "listening": "Listening"
            },
            "skillInstructions": {
              "reading": "- You may navigate freely between questions and return to previous questions until you submit the test.",
              "listening": "- Audio for each question will play automatically.\n- After the audio finishes, **a question level timer** will begin.\n- You cannot return to previous questions.\n- Questions advance automatically when the timer ends."
            }
          }
        }
      },
      "helpDialog": {
        "title": "Help – {{skill}}",
        "body": "#### Timing\n* **Total test time:** {{min}} minutes.\n{{timing}}\n#### Navigation\n{{navigation}}\n#### Question Types\n{{questionTypes}}\n#### Tips\n{{tips}}\n* Complete the test in one sitting for the most accurate assessment.",
        "skillVariables": {
          "tips": {
            "reading": "* Skip difficult questions and return to them later if needed.\n* Review unanswered questions before submitting.",
            "listening": "* Listen carefully before selecting your answer.\n* If a question includes a menu, chart, schedule, or map, use it to answer the question."
          },
          "skill": {
            "reading": "Reading",
            "listening": "Listening"
          },
          "timing": {
            "reading": "* Manage your own time across all questions.\n* Remaining time is displayed in the top-right corner.",
            "listening": "* Audio for each question will play automatically.\n* After the audio finishes, **a question level timer** will begin."
          },
          "navigation": {
            "reading": "* You may move freely between questions.\n* You may revisit and change your answers until you submit the test.",
            "listening": "* You **cannot return** to previous questions.\n* Questions advance automatically when the timer ends."
          },
          "questionTypes": {
            "reading": "* **Incomplete Sentences** – Complete a sentence with the best word or phrase.\n* **Text Completion** – Complete a passage using the best word, phrase, or sentence.\n* **Reading Comprehension** – Read one or more passages and answer the related questions.",
            "listening": "* **Photographs** – Select the statement that best describes the picture. _(5 seconds)_\n* **Question-Response** – Select the best response to the question or statement. _(5 seconds)_\n* **Conversations & Talks** – Answer questions based on a conversation or talk.\n  * **8 seconds** for questions without additional information.\n  * **12 seconds** for questions with supporting information (such as a menu, schedule, chart, or map)."
          }
        }
      },
      "testDriver": "toeic",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(137, 147, 141)",
          "primary": "rgb(130, 215, 183)",
          "surface": "rgb(25, 28, 26)",
          "backdrop": "rgba(41, 50, 46, 0.4)",
          "tertiary": "rgb(134, 209, 235)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(30, 37, 34)",
            "level2": "rgb(33, 43, 39)",
            "level3": "rgb(37, 49, 43)",
            "level4": "rgb(38, 50, 45)",
            "level5": "rgb(40, 54, 48)"
          },
          "onPrimary": "rgb(0, 56, 41)",
          "onSurface": "rgb(225, 227, 224)",
          "secondary": "rgb(156, 210, 187)",
          "background": "rgb(11, 15, 13)",
          "onTertiary": "rgb(0, 53, 67)",
          "onSecondary": "rgb(0, 56, 41)",
          "premiumChip": {
            "color": "#FFFFFF",
            "background": "rgba(255, 152, 0, 0.5)"
          },
          "onBackground": "rgb(225, 227, 224)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(44, 133, 105)",
          "inverseSurface": "rgb(225, 227, 224)",
          "outlineVariant": "rgb(64, 73, 68)",
          "surfaceVariant": "rgb(64, 73, 68)",
          "surfaceDisabled": "rgba(225, 227, 224, 0.12)",
          "inverseOnSurface": "rgb(46, 49, 47)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(191, 201, 195)",
          "primaryContainer": "rgb(0, 81, 61)",
          "onSurfaceDisabled": "rgba(225, 227, 224, 0.38)",
          "tertiaryContainer": "rgb(0, 78, 96)",
          "onPrimaryContainer": "rgb(157, 244, 210)",
          "secondaryContainer": "rgb(27, 79, 62)",
          "onTertiaryContainer": "rgb(181, 235, 255)",
          "onSecondaryContainer": "rgb(184, 238, 215)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 121, 116)",
          "primary": "rgb(44, 133, 105)",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(41, 50, 46, 0.4)",
          "tertiary": "rgb(0, 103, 126)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(240, 245, 243)",
            "level2": "rgb(234, 241, 238)",
            "level3": "rgb(227, 237, 234)",
            "level4": "rgb(224, 235, 232)",
            "level5": "rgb(217, 232, 227)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(25, 28, 26)",
          "secondary": "rgb(26, 79, 62)",
          "background": "rgb(251, 249, 243)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "premiumChip": {
            "color": "#E65100",
            "background": "rgba(251, 192, 45, 0.5)"
          },
          "onBackground": "rgb(25, 28, 26)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(114, 197, 168)",
          "inverseSurface": "rgb(46, 49, 47)",
          "outlineVariant": "rgb(191, 201, 195)",
          "surfaceVariant": "rgb(219, 229, 222)",
          "surfaceDisabled": "rgba(25, 28, 26, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 238)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 73, 68)",
          "primaryContainer": "rgb(188, 237, 224)",
          "onSurfaceDisabled": "rgba(25, 28, 26, 0.38)",
          "tertiaryContainer": "rgb(181, 235, 255)",
          "onPrimaryContainer": "rgb(12, 49, 37)",
          "secondaryContainer": "rgb(236, 244, 241)",
          "onTertiaryContainer": "rgb(0, 31, 40)",
          "onSecondaryContainer": "rgb(12, 49, 37)"
        }
      },
      "roundness": 0
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 06:56:30.437838+00"
  },
  "naplex": {
    "id": "naplex",
    "tenant": {
      "id": "1dcc1999-a81b-4b3b-b12c-07998995370a",
      "name": "McGrawHill"
    },
    "supportEmail": "info@mheducation.co.in",
    "companyName": "MCGRAW-HILL",
    "app": {
      "id": "f3b9420a-58c9-4207-91ff-a2c1a50be1c7",
      "name": "Naplex Practice Test Central",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "mhe.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1590041414"
        },
        "android": {
          "versionCode": 1,
          "package": "",
          "googleServicesJson": "73a57898-161a-4aa1-837f-e0ba27222a26",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.naplex",
          "buildNumberState": {
            "currentVersion": "1.0.0",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.6",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We are currently making improvements to enhance your experience. Naplex app will be down for maintenance from 12:30AM-6:30AM PT / 3:30AM-9:30AM ET. We apologize for any inconvenience and appreciate your patience. After the maintenance, the current version of the app will be deprecated. Please update the app from the App Store or Play Store to continue using it."
      },
      "font": "opensans",
      "trademark": "McGraw-Hill",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "6215161aec69547dd558954dcacc18cb"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/logo.jpg",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/app_default_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://accesspharmacy.mh.memorang.com/",
        "privacy": "https://www.mheducation.com/about-us/trust-center/privacy",
        "tos": "https://www.mheducation.com/about-us/policy-center/terms-use",
        "redeemSupportUrl": "https://www.mheducation.com/about-us/trust-center/privacy",
        "companyUrl": "https://www.mheducation.com/about-us/trust-center/privacy"
      },
      "keys": {
        "revenueCat": {
          "ios": "",
          "android": ""
        },
        "oneSignalAppId": "",
        "clerk": {
          "publishableKeyDev": "pk_test_ZGlyZWN0LXdoYWxlLTg1LmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYWNjZXNzcGhhcm1hY3kubWgubWVtb3JhbmcuY29tJA"
        }
      },
      "auth": {
        "tokenBasedFlow": true,
        "unauthorized": {
          "title": "We couldn’t verify your access.",
          "subtitle": "You’re not authorized to view this page. Go back to NAPLEX® Central on AccessPharmacy and try again.",
          "ctaLabel": "Go back",
          "ctaHref": "https://accesspharmacy.mhmedical.com/"
        }
      },
      "integrations": {
        "slack": {
          "channel": ""
        }
      },
      "supportUrl": "https://www.mheducation.co.in/",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "MHE",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/logo.jpg",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning agent, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "AccessPharmacy Test Prep for the NAPLEX",
          "decoratedText": "",
          "suffix": ""
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "NAPLEX Practice Questions",
            "subtitle": "Prepare with pharmacy-focused practice content from AccessPharmacy"
          },
          {
            "icon": "clipboard-text-outline",
            "title": "Exam-Focused Study",
            "subtitle": "Review questions and study materials designed to support NAPLEX preparation"
          },
          {
            "icon": "laptop",
            "title": "Web-Based Access",
            "subtitle": "Study online through the AccessPharmacy test prep application"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/ACME%20Mockup_light.webp"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "crossTagSelection": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_FZt6nhDpCVWUaPF9SgxR6qWMdETa",
            "deployedAt": "2026-08-12T01:27:25.634Z",
            "version": "1.0.6"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": false,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "brandingProfiles": {
        "medworld": {
          "theme": {
            "colors": {
              "dark": {
                "error": "rgb(255, 180, 171)",
                "scrim": "rgb(0, 0, 0)",
                "shadow": "rgb(0, 0, 0)",
                "onError": "rgb(105, 0, 5)",
                "outline": "rgb(160, 140, 138)",
                "primary": "rgb(255, 180, 172)",
                "surface": "rgb(32, 26, 25)",
                "backdrop": "rgba(54, 47, 46, 0.4)",
                "tertiary": "rgb(224, 195, 140)",
                "elevation": {
                  "level0": "transparent",
                  "level1": "rgb(43, 34, 32)",
                  "level2": "rgb(50, 38, 37)",
                  "level3": "rgb(57, 43, 41)",
                  "level4": "rgb(59, 44, 43)",
                  "level5": "rgb(63, 48, 46)"
                },
                "onPrimary": "rgb(105, 0, 7)",
                "onSurface": "rgb(237, 224, 222)",
                "secondary": "rgb(231, 189, 184)",
                "background": "rgb(18, 13, 12)",
                "onTertiary": "rgb(63, 45, 4)",
                "onSecondary": "rgb(68, 41, 39)",
                "premiumChip": {
                  "color": "#FFFFFF",
                  "background": "rgba(255, 152, 0, 0.5)"
                },
                "onBackground": "rgb(237, 224, 222)",
                "errorContainer": "rgb(147, 0, 10)",
                "inversePrimary": "rgb(192, 0, 22)",
                "inverseSurface": "rgb(237, 224, 222)",
                "outlineVariant": "rgb(83, 67, 65)",
                "surfaceVariant": "rgb(83, 67, 65)",
                "surfaceDisabled": "rgba(237, 224, 222, 0.12)",
                "inverseOnSurface": "rgb(54, 47, 46)",
                "onErrorContainer": "rgb(255, 180, 171)",
                "onSurfaceVariant": "rgb(216, 194, 191)",
                "primaryContainer": "rgb(147, 0, 14)",
                "onSurfaceDisabled": "rgba(237, 224, 222, 0.38)",
                "tertiaryContainer": "rgb(88, 68, 25)",
                "onPrimaryContainer": "rgb(255, 218, 214)",
                "secondaryContainer": "rgb(93, 63, 60)",
                "onTertiaryContainer": "rgb(254, 222, 166)",
                "onSecondaryContainer": "rgb(255, 218, 214)"
              },
              "light": {
                "error": "rgb(186, 26, 26)",
                "scrim": "rgb(0, 0, 0)",
                "shadow": "rgb(0, 0, 0)",
                "onError": "rgb(255, 255, 255)",
                "outline": "rgb(133, 115, 113)",
                "primary": "rgb(192, 0, 22)",
                "surface": "rgb(255, 255, 255)",
                "backdrop": "rgba(54, 47, 46, 0.4)",
                "tertiary": "rgb(114, 91, 46)",
                "elevation": {
                  "level0": "transparent",
                  "level1": "rgb(252, 242, 243)",
                  "level2": "rgb(250, 235, 236)",
                  "level3": "rgb(248, 227, 229)",
                  "level4": "rgb(247, 224, 227)",
                  "level5": "rgb(246, 219, 222)"
                },
                "onPrimary": "rgb(255, 255, 255)",
                "onSurface": "rgb(32, 26, 25)",
                "secondary": "rgb(119, 86, 83)",
                "background": "rgb(255, 248, 247)",
                "onTertiary": "rgb(255, 255, 255)",
                "onSecondary": "rgb(255, 255, 255)",
                "premiumChip": {
                  "color": "#E65100",
                  "background": "rgba(251, 192, 45, 0.5)"
                },
                "onBackground": "rgb(32, 26, 25)",
                "errorContainer": "rgb(255, 218, 214)",
                "inversePrimary": "rgb(255, 180, 172)",
                "inverseSurface": "rgb(54, 47, 46)",
                "outlineVariant": "rgb(216, 194, 191)",
                "surfaceVariant": "rgb(245, 221, 219)",
                "surfaceDisabled": "rgba(32, 26, 25, 0.12)",
                "inverseOnSurface": "rgb(251, 238, 236)",
                "onErrorContainer": "rgb(65, 0, 2)",
                "onSurfaceVariant": "rgb(83, 67, 65)",
                "primaryContainer": "rgb(255, 218, 214)",
                "onSurfaceDisabled": "rgba(32, 26, 25, 0.38)",
                "tertiaryContainer": "rgb(254, 222, 166)",
                "onPrimaryContainer": "rgb(65, 0, 3)",
                "secondaryContainer": "rgb(255, 218, 214)",
                "onTertiaryContainer": "rgb(38, 25, 0)",
                "onSecondaryContainer": "rgb(44, 21, 19)"
              }
            }
          },
          "logo": {
            "default": {
              "light": {
                "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/medworld_app_default_logo_dark.svg"
              },
              "dark": {
                "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/medworld_app_default_light.svg"
              }
            },
            "stacked": {
              "light": {
                "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/medworld_app_default_logo_dark.svg"
              },
              "dark": {
                "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/mcgraw-hill-education/icons/medworld_app_default_logo_dark.svg"
              }
            }
          }
        }
      },
      "branding": {
        "6e87815c-bff4-4f39-9064-2e6d0484df31": "medworld",
        "838d53cc-1cf3-4cad-8196-0e3c95c7c3b1": "medworld",
        "983ac700-0abc-4b2f-bfef-54feaabac907": "medworld"
      }
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": false,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "enableSessionReplay": false,
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": false,
        "aila": false
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(139, 147, 138)",
          "primary": "rgb(123, 218, 156)",
          "surface": "rgb(25, 28, 26)",
          "backdrop": "rgba(42, 50, 44, 0.4)",
          "tertiary": "rgb(163, 205, 218)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(30, 38, 33)",
            "level2": "rgb(33, 43, 36)",
            "level3": "rgb(36, 49, 40)",
            "level4": "rgb(37, 51, 42)",
            "level5": "rgb(39, 55, 44)"
          },
          "onPrimary": "rgb(0, 57, 29)",
          "onSurface": "rgb(225, 227, 222)",
          "secondary": "rgb(146, 204, 255)",
          "background": "rgb(12, 15, 12)",
          "onTertiary": "rgb(2, 54, 64)",
          "onSecondary": "rgb(0, 51, 81)",
          "onBackground": "rgb(225, 227, 222)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(0, 109, 61)",
          "inverseSurface": "rgb(225, 227, 222)",
          "outlineVariant": "rgb(65, 73, 66)",
          "surfaceVariant": "rgb(65, 73, 66)",
          "surfaceDisabled": "rgba(225, 227, 222, 0.12)",
          "inverseOnSurface": "rgb(46, 49, 46)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(192, 201, 191)",
          "primaryContainer": "rgb(0, 82, 45)",
          "onSurfaceDisabled": "rgba(225, 227, 222, 0.38)",
          "tertiaryContainer": "rgb(33, 76, 87)",
          "onPrimaryContainer": "rgb(151, 247, 183)",
          "secondaryContainer": "rgb(0, 75, 115)",
          "onTertiaryContainer": "rgb(190, 234, 247)",
          "onSecondaryContainer": "rgb(204, 229, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(113, 121, 113)",
          "primary": "rgb(0, 109, 61)",
          "surface": "rgb(251, 253, 248)",
          "backdrop": "rgba(43, 50, 44, 0.4)",
          "tertiary": "rgb(59, 100, 112)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 246, 239)",
            "level2": "rgb(231, 241, 233)",
            "level3": "rgb(223, 237, 227)",
            "level4": "rgb(221, 236, 226)",
            "level5": "rgb(216, 233, 222)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(25, 28, 26)",
          "secondary": "rgb(0, 100, 151)",
          "background": "rgb(240, 241, 236)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(25, 28, 26)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(123, 218, 156)",
          "inverseSurface": "rgb(46, 49, 46)",
          "outlineVariant": "rgb(192, 201, 191)",
          "surfaceVariant": "rgb(220, 229, 219)",
          "surfaceDisabled": "rgba(25, 28, 26, 0.12)",
          "inverseOnSurface": "rgb(240, 241, 236)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(65, 73, 66)",
          "primaryContainer": "rgb(151, 247, 183)",
          "onSurfaceDisabled": "rgba(25, 28, 26, 0.38)",
          "tertiaryContainer": "rgb(190, 234, 247)",
          "onPrimaryContainer": "rgb(0, 33, 15)",
          "secondaryContainer": "rgb(204, 229, 255)",
          "onTertiaryContainer": "rgb(0, 31, 38)",
          "onSecondaryContainer": "rgb(0, 30, 49)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 11:43:03.314212+00"
  },
  "nascla": {
    "id": "nascla",
    "tenant": {
      "id": "6635a8d9-38e4-4051-928c-42df9e591995",
      "name": "NASCLA"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "NASCLA",
    "app": {
      "id": "bcba4050-d047-49c7-a863-ad0d3b7b799c",
      "name": "NASCLA Exam Prep and Directory",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "nascla.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6752681081"
        },
        "android": {
          "versionCode": 20,
          "package": "com.memorang.nascla",
          "googleServicesJson": "48620254-487b-44a1-80e6-6319e8a76cd6",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.nascla",
          "buildNumberState": {
            "currentVersion": "1.0.23",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.23",
      "maintenance": {
        "enabled": false,
        "title": "We'll be right back",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "opensans",
      "trademark": "NASCLA",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 16,
        "answer": 16,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "282437d9532186634a11c1766aaa9d79"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/icon.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/icon.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_default_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_default_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.nascla.psiexams.com",
        "privacy": "https://app.nascla.psiexams.com/legal/privacy",
        "tos": "https://app.nascla.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/app/id6752681081",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.nascla&hl=en&gl=US",
        "companyUrl": "https://www.nascla.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_ccxywHbvHLWINlyzqbXuejIwZFj",
          "android": "goog_MwTFBdxrtZcnfnbKAnxdFEfhmAO"
        },
        "oneSignalAppId": "72f30699-4b1c-4ec7-9795-747a60cd5045",
        "clerk": {
          "publishableKeyDev": "pk_test_c3dlZXBpbmctZW11LTY3LmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLm5hc2NsYS5wc2lleGFtcy5jb20k"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "NASCLA Ai Learning Agent",
        "alias": "NAiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/nascla/assets/icons/icon.png",
        "showOriginalQuestion": false,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for NASCLA Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official NASCLA team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalized AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "contentStatusFilters": {
          "visibleStatuses": [
            "PUBLISHED"
          ]
        },
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showFaqs": false,
        "showPurchasedProducts": false,
        "showCurrentExam": true,
        "faqs": [],
        "showLanguageSettings": false,
        "showAudioTestDialog": false,
        "showPartnersSection": false
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": false
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_Fqut1af9ZyetoVK6cR9EEGPtyMLu",
            "deployedAt": "2026-05-07T16:09:05.569Z",
            "version": "1.0.23"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Topic Mastery",
      "showRedeem": true,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Library",
            "name": "(articles)/articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Directory",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "testDriver": "default",
      "showFlightCalculator": false,
      "allowMarking": true,
      "showCrossOut": true,
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(163, 201, 255)",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(45, 49, 55, 0.4)",
          "tertiary": "rgb(217, 189, 227)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(41, 47, 55)",
            "level4": "rgb(42, 49, 57)",
            "level5": "rgb(45, 52, 62)"
          },
          "onPrimary": "rgb(0, 49, 92)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(255, 182, 136)",
          "background": "rgb(13, 14, 17)",
          "onTertiary": "rgb(61, 41, 71)",
          "onSecondary": "rgb(81, 36, 0)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(22, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 130)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(84, 63, 94)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "rgb(115, 53, 0)",
          "onTertiaryContainer": "rgb(246, 217, 255)",
          "onSecondaryContainer": "rgb(255, 219, 199)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(115, 119, 127)",
          "primary": "rgb(22, 96, 165)",
          "surface": "rgb(253, 252, 255)",
          "backdrop": "rgba(45, 49, 55, 0.4)",
          "tertiary": "rgb(109, 86, 119)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(241, 244, 251)",
            "level2": "rgb(235, 240, 248)",
            "level3": "rgb(228, 235, 245)",
            "level4": "rgb(225, 233, 244)",
            "level5": "rgb(221, 230, 242)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(26, 28, 30)",
          "secondary": "rgb(149, 73, 7)",
          "background": "rgb(241, 240, 244)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(26, 28, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(163, 201, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(195, 198, 207)",
          "surfaceVariant": "rgb(223, 226, 235)",
          "surfaceDisabled": "rgba(26, 28, 30, 0.12)",
          "inverseOnSurface": "rgb(241, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(67, 71, 78)",
          "primaryContainer": "rgb(211, 228, 255)",
          "onSurfaceDisabled": "rgba(26, 28, 30, 0.38)",
          "tertiaryContainer": "rgb(246, 217, 255)",
          "onPrimaryContainer": "rgb(0, 28, 56)",
          "secondaryContainer": "rgb(255, 219, 199)",
          "onTertiaryContainer": "rgb(39, 20, 48)",
          "onSecondaryContainer": "rgb(49, 19, 0)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 13:27:44.054341+00"
  },
  "psi": {
    "id": "psi",
    "tenant": {
      "id": "dcfc373c-0870-4a88-88c3-4a706de51463",
      "name": "PSI"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "PSI",
    "app": {
      "id": "2c183c41-6dc0-4ef4-837c-0eb0f86a61b1",
      "name": "PSI Test Prep",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "psi.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1565909858"
        },
        "android": {
          "versionCode": 137,
          "package": "com.memorang.psi.insurance.testprep",
          "googleServicesJson": "c4e1d731-8e5a-4d9a-a6c0-694c2117e1a7",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.insurance",
          "buildNumberState": {
            "currentVersion": "2.1.49",
            "buildNumber": 1
          }
        }
      },
      "version": "2.1.51",
      "maintenance": {
        "enabled": false,
        "title": "We'll be right back",
        "urls": {
          "ios": "https://apps.apple.com/us/app/psi-test-prep/id1565909858",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en_IN"
        },
        "subtitle": "We are currently making improvements to enhance your experience. The PSI app is temporarily unavailable due to maintenance. We apologize for any inconvenience and appreciate your patience. Once maintenance is complete, the current version of the app will no longer be supported. 👉 If you are on mobile, please update to the latest version of the app from the App Store or Google Play Store to continue using it."
      },
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 16,
        "answer": 16,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "e2354d451161a9deacf641952f49ab00"
        }
      },
      "logo": {
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/icon.png",
        "adaptiveIcon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_light.png?t=2024-09-11T02%3A52%3A07.652Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_dark.png?t=2024-09-11T02%3A52%3A21.053Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_light.png?t=2024-09-11T02%3A52%3A32.632Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_dark.png?t=2024-09-11T02%3A52%3A42.516Z"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.psiexams.com",
        "privacy": "https://app.psiexams.com/legal/privacy",
        "tos": "https://app.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "redeemSupportUrl": "https://app.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_tfbBxQbsoZLVyISjLSZWoccqCzi",
          "android": "goog_xnLVKZpZmlknMbzVJXNOLTdigye"
        },
        "oneSignalAppId": "67d6088f-0bcd-4d04-9984-b5f8efa0dcfc",
        "clerk": {
          "publishableKeyDev": "pk_test_Z2FtZS1saW9uZXNzLTgyLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "AiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/assistant/assistant_dark.png?t=2024-09-20T04%3A10%3A34.686Z",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_6iigTTJWgmWR3PsZkmK2UbtZ8N4P",
            "deployedAt": "2026-08-19T07:01:21.370Z",
            "version": "2.1.51"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "whiteListedExamIds": [
        "fa"
      ],
      "quizEnabled": true,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Topics",
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "isMobile": true,
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "icon": "shield-check-outline"
          },
          {
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "icon": "lock-outline"
          },
          {
            "titlei18n": {
              "en-US": "You control your data"
            },
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "icon": "account-cog-outline"
          },
          {
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseCategory",
        "enabled": true,
        "titlei18n": {
          "en-US": "What are you studying for?"
        },
        "descriptioni18n": {
          "en-US": "Choose the category that applies"
        }
      },
      {
        "step": "chooseLevel",
        "enabled": true,
        "titlei18n": {
          "en-US": "Which level are you preparing for?"
        },
        "descriptioni18n": {
          "en-US": "Choose one of the options below"
        }
      },
      {
        "step": "chooseState",
        "enabled": true,
        "titlei18n": {
          "en-US": "Select state for the exam"
        },
        "descriptioni18n": {
          "en-US": "Choose the state where you will take the exam"
        }
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your exam"
        },
        "descriptioni18n": {
          "en-US": "Select your exam to get a personalized study plan"
        }
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your exam date"
        },
        "descriptioni18n": {
          "en-US": "We’ll tailor your study plan based on this date"
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "enableSessionReplay": false,
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "#103D4B",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "#F2E9D8",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "#BC5221",
          "background": "rgb(247, 247, 247)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "#fff",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(93, 212, 252)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(184, 234, 255)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(219, 236, 121)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "#F2E9D8",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "#1A212B"
        }
      },
      "roundness": 0
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-19 07:01:21.418576+00"
  },
  "pte": {
    "id": "pte",
    "tenant": {
      "id": "e6bc78c9-96f1-45a0-b3ad-858748f9ae9f",
      "name": "PTE"
    },
    "supportEmail": "info@pte.com",
    "companyName": "Pearson",
    "app": {
      "id": "df79bd86-51f0-4ab8-ad60-6695a15a85c7",
      "name": "PTE AI Practice",
      "template": "language-learning",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "pte.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1590041414"
        },
        "android": {
          "versionCode": 3,
          "package": "com.officialpteaipractice.app",
          "googleServicesJson": "98dfd2e4-2846-4df0-b0e8-cbfdaf487cd5",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.officialpteaipractice.app",
          "buildNumberState": {
            "currentVersion": "1.0.0",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.74",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We are currently making improvements to enhance your experience. PTE app will be down for maintenance from 12:30AM-6:30AM PT / 3:30AM-9:30AM ET. We apologize for any inconvenience and appreciate your patience. After the maintenance, the current version of the app will be deprecated. Please update the app from the App Store or Play Store to continue using it."
      },
      "font": "plusjakartasans",
      "trademark": "Pearson",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              49
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Needs work"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              50,
              84
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              85,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "proficiencyLevels": [
        {
          "id": "pte_b1",
          "darkColor": "#dda53a",
          "lightColor": "#FFE4B2",
          "sortOrder": 1,
          "icon": "book-open-variant-outline",
          "range": {
            "type": "percentage",
            "score": [
              0,
              25
            ],
            "points": [
              0,
              25
            ]
          },
          "alias": {
            "title": "B1"
          },
          "level": "b1"
        },
        {
          "id": "pte_b2",
          "darkColor": "#c9b44e",
          "lightColor": "#FFF3B0",
          "sortOrder": 2,
          "icon": "certificate-outline",
          "range": {
            "type": "percentage",
            "score": [
              25,
              50
            ],
            "points": [
              25,
              50
            ]
          },
          "alias": {
            "title": "B2"
          },
          "level": "b2"
        },
        {
          "id": "pte_c1",
          "darkColor": "#7cb870",
          "lightColor": "#D4F0CB",
          "sortOrder": 3,
          "icon": "medal-outline",
          "range": {
            "type": "percentage",
            "score": [
              50,
              75
            ],
            "points": [
              50,
              75
            ]
          },
          "alias": {
            "title": "C1"
          },
          "level": "c1"
        },
        {
          "id": "pte_c2",
          "darkColor": "#4caf50",
          "lightColor": "#BBF0B5",
          "sortOrder": 4,
          "icon": "crown-outline",
          "range": {
            "type": "percentage",
            "score": [
              75,
              100
            ],
            "points": [
              75,
              100
            ]
          },
          "alias": {
            "title": "C2"
          },
          "level": "c2"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": true,
      "fontSizes": {
        "stem": 16,
        "answer": 16,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "257775ade8a6bfcdc1118fcf0c441846"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/icon.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/aicon.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/app_logo_default_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/app_logo_default_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/company_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/company_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.practice.pearsonpte.com",
        "privacy": "https://www.pearson.com/en-us/privacy-center/privacy-notices.html",
        "tos": "https://www.pearson.com/en-us/legal-information/terms-of-use.html",
        "redeemSupportUrl": "https://www.pearson.com/",
        "companyUrl": "https://www.pearson.com/",
        "contactSupportUrl": "https://www.pearsonpte.com/help-center/"
      },
      "keys": {
        "revenueCat": {
          "ios": "",
          "android": "goog_ZiHsfwXKLPqgmPHQyvrOpdvBYmt"
        },
        "oneSignalAppId": "9f24b63d-35c0-417c-a7b1-a5880060ad4c",
        "clerk": {
          "publishableKeyDev": "pk_test_cHJlbWl1bS1yaW5ndGFpbC03My5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnByYWN0aWNlLnBlYXJzb25wdGUuY29tJA"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-pearson-shared"
        }
      },
      "supportUrl": "https://www.pearson.com/",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "PTE AI",
        "fabIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/aila_dark.png",
        "fabDarkIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/aila_light.png",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/aila_light.png",
        "darkIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/aila_dark.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm **{{alias}}** learning agent, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PTE AI Practice"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official Pearson team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/pearson/pte/icons/landing.png"
      },
      "showCountrySelection": false,
      "avatarType": "glass",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": false,
        "showDurationSelection": true,
        "showLearningMode": true,
        "crossTagSelection": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showLanguageSettings": true,
        "showAudioTestDialog": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_7Xy5rFmK4HKcyz8NDcHM5uxtLs5U",
            "deployedAt": "2026-08-20T06:56:30.227Z",
            "version": "1.0.74"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US",
          "en-GB",
          "es-MX",
          "fil-PH",
          "hi-IN",
          "id-ID",
          "pa-IN",
          "pt-BR",
          "th-TH",
          "tr-TR",
          "vi-VN",
          "zh-CN"
        ],
        "fallbackLocale": "en-GB",
        "defaultToDeviceLocale": true,
        "overrides": {}
      },
      "onboarding": {
        "requiredFields": [
          "learner_type_id",
          "target_level_id",
          "plan_id",
          "skill_ids"
        ]
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      }
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "showRedeem": true,
      "headerIconMode": "company"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": true
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "welcome",
        "enabled": true,
        "titlei18n": {
          "en-US": "Welcome to the official PTE AI Practice app",
          "es-MX": "Bienvenido a la aplicación oficial PTE AI Practice",
          "fr-FR": "Bienvenue sur l'application officielle PTE AI Practice",
          "id-ID": "Selamat datang di aplikasi resmi PTE AI Practice",
          "ms-MY": "Selamat datang ke aplikasi rasmi PTE AI Practice",
          "pt-BR": "Bem-vindo ao aplicativo oficial PTE AI Practice",
          "tr-TR": "Resmi PTE AI Practice uygulamasına hoş geldiniz",
          "vi-VN": "Chào mừng bạn đến với ứng dụng PTE AI Practice chính thức"
        },
        "descriptioni18n": {
          "en-US": "Answer a few quick questions so we can personalize your PTE study plan and recommendations.",
          "es-MX": "Responde algunas preguntas rápidas para que podamos personalizar tu plan de estudio y recomendaciones para el PTE.",
          "fr-FR": "Répondez à quelques questions rapides afin que nous puissions personnaliser votre plan d'étude PTE et nos recommandations.",
          "id-ID": "Jawab beberapa pertanyaan singkat agar kami dapat menyesuaikan rencana belajar dan rekomendasi PTE Anda.",
          "ms-MY": "Jawab beberapa soalan ringkas supaya kami dapat menyesuaikan pelan pembelajaran dan cadangan PTE anda.",
          "pt-BR": "Responda algumas perguntas rápidas para que possamos personalizar seu plano de estudos e recomendações do PTE.",
          "tr-TR": "PTE çalışma planınızı ve önerilerinizi kişiselleştirebilmemiz için birkaç hızlı soruyu yanıtlayın.",
          "vi-VN": "Trả lời một vài câu hỏi nhanh để chúng tôi có thể cá nhân hóa kế hoạch học tập và đề xuất PTE của bạn."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Takes just 60 seconds",
              "es-MX": "Solo toma 60 segundos",
              "fr-FR": "Ne prend que 60 secondes",
              "id-ID": "Hanya butuh 60 detik",
              "ms-MY": "Hanya mengambil masa 60 saat",
              "pt-BR": "Leva apenas 60 segundos",
              "tr-TR": "Sadece 60 saniye sürer",
              "vi-VN": "Chỉ mất 60 giây"
            },
            "icon": "clock-outline"
          },
          {
            "titlei18n": {
              "en-US": "Tailored to your goals",
              "es-MX": "Adaptado a tus objetivos",
              "fr-FR": "Adapté à vos objectifs",
              "id-ID": "Disesuaikan dengan tujuan Anda",
              "ms-MY": "Disesuaikan dengan matlamat anda",
              "pt-BR": "Personalizado para seus objetivos",
              "tr-TR": "Hedeflerinize göre uyarlanır",
              "vi-VN": "Phù hợp với mục tiêu của bạn"
            },
            "icon": "chart-box-outline"
          },
          {
            "titlei18n": {
              "en-US": "Your data stays protected",
              "es-MX": "Tus datos permanecen protegidos",
              "fr-FR": "Vos données restent protégées",
              "id-ID": "Data Anda tetap terlindungi",
              "ms-MY": "Data anda kekal dilindungi",
              "pt-BR": "Seus dados permanecem protegidos",
              "tr-TR": "Verileriniz korunmaya devam eder",
              "vi-VN": "Dữ liệu của bạn luôn được bảo vệ"
            },
            "icon": "account-circle-outline"
          }
        ]
      },
      {
        "step": "profile",
        "enabled": true,
        "titlei18n": {
          "en-US": "What should we call you?",
          "es-MX": "¿Cómo debemos llamarte?",
          "fr-FR": "Comment devons-nous vous appeler ?",
          "id-ID": "Bagaimana kami harus memanggil Anda?",
          "ms-MY": "Apakah nama panggilan anda?",
          "pt-BR": "Como devemos te chamar?",
          "tr-TR": "Size nasıl hitap etmeliyiz?",
          "vi-VN": "Chúng tôi nên gọi bạn là gì?"
        },
        "labeli18n": {
          "en-US": "Profile",
          "es-MX": "Perfil",
          "fr-FR": "Profil",
          "id-ID": "Profil",
          "ms-MY": "Profil",
          "pt-BR": "Perfil",
          "tr-TR": "Profil",
          "vi-VN": "Hồ sơ"
        },
        "descriptioni18n": {
          "en-US": "Your name and avatar appear on your dashboard, reports, and leaderboard.",
          "es-MX": "Tu nombre y avatar aparecen en tu panel, tus reportes y la tabla de clasificación.",
          "fr-FR": "Votre nom et votre avatar apparaissent sur votre tableau de bord, vos rapports et le classement.",
          "id-ID": "Nama dan avatar Anda akan muncul di dasbor, laporan, dan papan peringkat Anda.",
          "ms-MY": "Nama dan avatar anda akan dipaparkan pada papan pemuka, laporan dan papan pendahulu anda.",
          "pt-BR": "Seu nome e avatar aparecem no seu painel, relatórios e ranking.",
          "tr-TR": "Adınız ve avatarınız panonuzda, raporlarınızda ve liderlik tablosunda görünür.",
          "vi-VN": "Tên và ảnh đại diện của bạn sẽ hiển thị trên bảng điều khiển, báo cáo và bảng xếp hạng."
        }
      },
      {
        "step": "learnerType",
        "enabled": true,
        "titlei18n": {
          "en-US": "What best describes you?",
          "es-MX": "¿Qué te describe mejor?",
          "fr-FR": "Qu'est-ce qui vous décrit le mieux ?",
          "id-ID": "Mana yang paling menggambarkan Anda?",
          "ms-MY": "Apakah yang paling menggambarkan diri anda?",
          "pt-BR": "O que melhor te descreve?",
          "tr-TR": "Sizi en iyi ne tanımlar?",
          "vi-VN": "Điều gì mô tả đúng nhất về bạn?"
        },
        "labeli18n": {
          "en-US": "Learner type",
          "es-MX": "Tipo de estudiante",
          "fr-FR": "Type d'apprenant",
          "id-ID": "Tipe pembelajar",
          "ms-MY": "Jenis pelajar",
          "pt-BR": "Tipo de aluno",
          "tr-TR": "Öğrenci türü",
          "vi-VN": "Loại người học"
        },
        "descriptioni18n": {
          "en-US": "We'll use this to guide you to the best starting point.",
          "es-MX": "Usaremos esto para guiarte hacia el mejor punto de partida.",
          "fr-FR": "Nous utiliserons cette information pour vous orienter vers le meilleur point de départ.",
          "id-ID": "Kami akan menggunakan ini untuk mengarahkan Anda ke titik awal terbaik.",
          "ms-MY": "Kami akan menggunakan maklumat ini untuk membimbing anda ke titik permulaan terbaik.",
          "pt-BR": "Usaremos isso para te orientar ao melhor ponto de partida.",
          "tr-TR": "Bunu, sizi en iyi başlangıç noktasına yönlendirmek için kullanacağız.",
          "vi-VN": "Chúng tôi sẽ dùng thông tin này để hướng dẫn bạn đến điểm khởi đầu tốt nhất."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "First-time test taker",
              "es-MX": "Presentas el examen por primera vez",
              "fr-FR": "Vous passez l'examen pour la première fois",
              "id-ID": "Peserta ujian pertama kali",
              "ms-MY": "Kali pertama mengambil peperiksaan",
              "pt-BR": "Vai fazer a prova pela primeira vez",
              "tr-TR": "İlk kez sınava giriyor",
              "vi-VN": "Thi lần đầu tiên"
            },
            "descriptioni18n": {
              "en-US": "I haven't taken PTE before",
              "es-MX": "Nunca he presentado el PTE",
              "fr-FR": "Je n'ai jamais passé le PTE",
              "id-ID": "Saya belum pernah mengikuti PTE sebelumnya",
              "ms-MY": "Saya belum pernah mengambil PTE sebelum ini",
              "pt-BR": "Nunca fiz o PTE antes",
              "tr-TR": "Daha önce hiç PTE sınavına girmedim",
              "vi-VN": "Tôi chưa từng thi PTE trước đây"
            },
            "icon": "bullseye-arrow",
            "type": "first-time"
          },
          {
            "titlei18n": {
              "en-US": "Retaking the exam",
              "es-MX": "Vuelves a presentar el examen",
              "fr-FR": "Vous repassez l'examen",
              "id-ID": "Mengulang ujian",
              "ms-MY": "Mengambil semula peperiksaan",
              "pt-BR": "Vai refazer a prova",
              "tr-TR": "Sınava yeniden giriyor",
              "vi-VN": "Thi lại"
            },
            "descriptioni18n": {
              "en-US": "I want to improve my previous score",
              "es-MX": "Quiero mejorar mi puntuación anterior",
              "fr-FR": "Je veux améliorer mon score précédent",
              "id-ID": "Saya ingin meningkatkan skor sebelumnya",
              "ms-MY": "Saya ingin meningkatkan skor terdahulu saya",
              "pt-BR": "Quero melhorar minha pontuação anterior",
              "tr-TR": "Önceki puanımı geliştirmek istiyorum",
              "vi-VN": "Tôi muốn cải thiện điểm số trước đây của mình"
            },
            "icon": "refresh",
            "type": "retaking"
          },
          {
            "titlei18n": {
              "en-US": "Just exploring",
              "es-MX": "Solo estás explorando",
              "fr-FR": "Vous vous renseignez seulement",
              "id-ID": "Sekadar menjelajah",
              "ms-MY": "Sekadar meneroka",
              "pt-BR": "Só está explorando",
              "tr-TR": "Sadece göz atıyor",
              "vi-VN": "Chỉ đang tìm hiểu"
            },
            "descriptioni18n": {
              "en-US": "I'm curious about this exam",
              "es-MX": "Tengo curiosidad por este examen",
              "fr-FR": "Je suis curieux(se) à propos de cet examen",
              "id-ID": "Saya penasaran dengan ujian ini",
              "ms-MY": "Saya ingin tahu tentang peperiksaan ini",
              "pt-BR": "Tenho curiosidade sobre essa prova",
              "tr-TR": "Bu sınav hakkında meraklıyım",
              "vi-VN": "Tôi tò mò về kỳ thi này"
            },
            "icon": "file-search-outline",
            "type": "exploring"
          }
        ]
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "When is your PTE exam?",
          "es-MX": "¿Cuándo es tu examen PTE?",
          "fr-FR": "Quand a lieu votre examen PTE ?",
          "id-ID": "Kapan ujian PTE Anda?",
          "ms-MY": "Bilakah peperiksaan PTE anda?",
          "pt-BR": "Quando é sua prova do PTE?",
          "tr-TR": "PTE sınavınız ne zaman?",
          "vi-VN": "Khi nào bạn thi PTE?"
        },
        "labeli18n": {
          "en-US": "Exam date",
          "es-MX": "Fecha del examen",
          "fr-FR": "Date de l'examen",
          "id-ID": "Tanggal ujian",
          "ms-MY": "Tarikh peperiksaan",
          "pt-BR": "Data da prova",
          "tr-TR": "Sınav tarihi",
          "vi-VN": "Ngày thi"
        },
        "descriptioni18n": {
          "en-US": "The closer your exam date, the more focused your study plan will be.",
          "es-MX": "Cuanto más cerca esté la fecha de tu examen, más enfocado será tu plan de estudio.",
          "fr-FR": "Plus votre date d'examen est proche, plus votre plan d'étude sera ciblé.",
          "id-ID": "Semakin dekat tanggal ujian Anda, semakin fokus rencana belajar Anda.",
          "ms-MY": "Semakin dekat tarikh peperiksaan anda, semakin fokus pelan pembelajaran anda.",
          "pt-BR": "Quanto mais próxima estiver a data da sua prova, mais focado será seu plano de estudos.",
          "tr-TR": "Sınav tarihiniz yaklaştıkça çalışma planınız daha odaklı hale gelir.",
          "vi-VN": "Ngày thi càng gần, kế hoạch học tập của bạn sẽ càng tập trung."
        }
      },
      {
        "step": "rank",
        "enabled": true,
        "titlei18n": {
          "en-US": "What's your current English level?",
          "es-MX": "¿Cuál es tu nivel actual de inglés?",
          "fr-FR": "Quel est votre niveau d'anglais actuel ?",
          "id-ID": "Apa tingkat bahasa Inggris Anda saat ini?",
          "ms-MY": "Apakah tahap Bahasa Inggeris anda sekarang?",
          "pt-BR": "Qual é o seu nível atual de inglês?",
          "tr-TR": "Mevcut İngilizce seviyeniz nedir?",
          "vi-VN": "Trình độ tiếng Anh hiện tại của bạn là gì?"
        },
        "labeli18n": {
          "en-US": "English level",
          "es-MX": "Nivel de inglés",
          "fr-FR": "Niveau d'anglais",
          "id-ID": "Tingkat bahasa Inggris",
          "ms-MY": "Tahap Bahasa Inggeris",
          "pt-BR": "Nível de inglês",
          "tr-TR": "İngilizce seviyesi",
          "vi-VN": "Trình độ tiếng Anh"
        },
        "descriptioni18n": {
          "en-US": "Choose the level that best matches your current ability.",
          "es-MX": "Elige el nivel que mejor se ajuste a tu capacidad actual.",
          "fr-FR": "Choisissez le niveau qui correspond le mieux à votre capacité actuelle.",
          "id-ID": "Pilih tingkat yang paling sesuai dengan kemampuan Anda saat ini.",
          "ms-MY": "Pilih tahap yang paling sesuai dengan keupayaan anda sekarang.",
          "pt-BR": "Escolha o nível que melhor corresponde à sua habilidade atual.",
          "tr-TR": "Mevcut yeteneğinize en uygun seviyeyi seçin.",
          "vi-VN": "Chọn trình độ phù hợp nhất với khả năng hiện tại của bạn."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Intermediate",
              "es-MX": "Intermedio",
              "fr-FR": "Intermédiaire",
              "id-ID": "Menengah",
              "ms-MY": "Pertengahan",
              "pt-BR": "Intermediário",
              "tr-TR": "Orta düzey",
              "vi-VN": "Trung cấp"
            },
            "descriptioni18n": {
              "en-US": "I can handle everyday communication and routine situations.",
              "es-MX": "Puedo manejar la comunicación cotidiana y situaciones rutinarias.",
              "fr-FR": "Je peux gérer la communication quotidienne et les situations courantes.",
              "id-ID": "Saya dapat menangani komunikasi sehari-hari dan situasi rutin.",
              "ms-MY": "Saya boleh mengendalikan komunikasi harian dan situasi rutin.",
              "pt-BR": "Consigo lidar com a comunicação do dia a dia e situações rotineiras.",
              "tr-TR": "Günlük iletişimi ve rutin durumları yönetebilirim.",
              "vi-VN": "Tôi có thể giao tiếp hằng ngày và xử lý các tình huống thông thường."
            },
            "iconString": "B1",
            "type": "B1"
          },
          {
            "titlei18n": {
              "en-US": "Upper Intermediate",
              "es-MX": "Intermedio alto",
              "fr-FR": "Intermédiaire avancé",
              "id-ID": "Menengah Atas",
              "ms-MY": "Pertengahan Atasan",
              "pt-BR": "Intermediário superior",
              "tr-TR": "Orta üstü düzey",
              "vi-VN": "Trung cấp cao"
            },
            "descriptioni18n": {
              "en-US": "I can discuss a wide range of topics and understand detailed information.",
              "es-MX": "Puedo hablar de una amplia variedad de temas y comprender información detallada.",
              "fr-FR": "Je peux discuter d'un large éventail de sujets et comprendre des informations détaillées.",
              "id-ID": "Saya dapat membahas berbagai topik dan memahami informasi secara rinci.",
              "ms-MY": "Saya boleh membincangkan pelbagai topik dan memahami maklumat terperinci.",
              "pt-BR": "Consigo discutir uma ampla variedade de tópicos e entender informações detalhadas.",
              "tr-TR": "Geniş bir konu yelpazesini tartışabilir ve ayrıntılı bilgileri anlayabilirim.",
              "vi-VN": "Tôi có thể thảo luận nhiều chủ đề khác nhau và hiểu thông tin chi tiết."
            },
            "iconString": "B2",
            "type": "B2"
          },
          {
            "titlei18n": {
              "en-US": "Advanced",
              "es-MX": "Avanzado",
              "fr-FR": "Avancé",
              "id-ID": "Mahir",
              "ms-MY": "Mahir",
              "pt-BR": "Avançado",
              "tr-TR": "İleri düzey",
              "vi-VN": "Nâng cao"
            },
            "descriptioni18n": {
              "en-US": "I can communicate fluently and understand complex material.",
              "es-MX": "Puedo comunicarme con fluidez y comprender material complejo.",
              "fr-FR": "Je peux communiquer couramment et comprendre des contenus complexes.",
              "id-ID": "Saya dapat berkomunikasi dengan lancar dan memahami materi yang kompleks.",
              "ms-MY": "Saya boleh berkomunikasi dengan lancar dan memahami bahan yang kompleks.",
              "pt-BR": "Consigo me comunicar com fluência e entender conteúdos complexos.",
              "tr-TR": "Akıcı bir şekilde iletişim kurabilir ve karmaşık materyalleri anlayabilirim.",
              "vi-VN": "Tôi có thể giao tiếp trôi chảy và hiểu các tài liệu phức tạp."
            },
            "iconString": "C1",
            "type": "C1"
          },
          {
            "titlei18n": {
              "en-US": "Proficient",
              "es-MX": "Competente",
              "fr-FR": "Confirmé",
              "id-ID": "Sangat Mahir",
              "ms-MY": "Cekap",
              "pt-BR": "Proficiente",
              "tr-TR": "Yetkin",
              "vi-VN": "Thành thạo"
            },
            "descriptioni18n": {
              "en-US": "I can understand and express ideas with near-native proficiency.",
              "es-MX": "Puedo comprender y expresar ideas con un nivel casi nativo.",
              "fr-FR": "Je peux comprendre et exprimer des idées avec un niveau proche de la langue maternelle.",
              "id-ID": "Saya dapat memahami dan mengungkapkan ide dengan kemahiran hampir seperti penutur asli.",
              "ms-MY": "Saya boleh memahami dan meluahkan idea hampir seperti penutur asli.",
              "pt-BR": "Consigo entender e expressar ideias com proficiência quase nativa.",
              "tr-TR": "Neredeyse ana dile yakın bir yetkinlikle fikirleri anlayabilir ve ifade edebilirim.",
              "vi-VN": "Tôi có thể hiểu và diễn đạt ý tưởng với trình độ gần như người bản ngữ."
            },
            "iconString": "C2",
            "type": "C2"
          }
        ]
      },
      {
        "step": "skill",
        "enabled": true,
        "titlei18n": {
          "en-US": "What do you want to improve most?",
          "es-MX": "¿Qué es lo que más quieres mejorar?",
          "fr-FR": "Qu'est-ce que vous souhaitez améliorer en priorité ?",
          "id-ID": "Apa yang paling ingin Anda tingkatkan?",
          "ms-MY": "Apakah yang paling anda ingin tingkatkan?",
          "pt-BR": "O que você mais quer melhorar?",
          "tr-TR": "En çok neyi geliştirmek istiyorsunuz?",
          "vi-VN": "Bạn muốn cải thiện điều gì nhất?"
        },
        "labeli18n": {
          "en-US": "Focus areas",
          "es-MX": "Áreas de enfoque",
          "fr-FR": "Domaines à travailler",
          "id-ID": "Area fokus",
          "ms-MY": "Bidang tumpuan",
          "pt-BR": "Áreas de foco",
          "tr-TR": "Odak alanları",
          "vi-VN": "Lĩnh vực trọng tâm"
        },
        "descriptioni18n": {
          "en-US": "We'll tailor your recommendations around these skills.",
          "es-MX": "Adaptaremos tus recomendaciones en función de estas habilidades.",
          "fr-FR": "Nous adapterons nos recommandations autour de ces compétences.",
          "id-ID": "Kami akan menyesuaikan rekomendasi Anda berdasarkan keterampilan ini.",
          "ms-MY": "Kami akan menyesuaikan cadangan anda berdasarkan kemahiran ini.",
          "pt-BR": "Vamos personalizar suas recomendações com base nessas habilidades.",
          "tr-TR": "Önerilerinizi bu becerilere göre uyarlayacağız.",
          "vi-VN": "Chúng tôi sẽ điều chỉnh đề xuất của bạn dựa trên các kỹ năng này."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Speaking",
              "es-MX": "Speaking",
              "fr-FR": "Speaking",
              "id-ID": "Speaking",
              "ms-MY": "Speaking",
              "pt-BR": "Speaking",
              "tr-TR": "Speaking",
              "vi-VN": "Speaking"
            },
            "icon": "microphone",
            "type": "speaking"
          },
          {
            "titlei18n": {
              "en-US": "Writing",
              "es-MX": "Writing",
              "fr-FR": "Writing",
              "id-ID": "Writing",
              "ms-MY": "Writing",
              "pt-BR": "Writing",
              "tr-TR": "Writing",
              "vi-VN": "Writing"
            },
            "icon": "pencil-outline",
            "type": "writing"
          },
          {
            "titlei18n": {
              "en-US": "Reading",
              "es-MX": "Reading",
              "fr-FR": "Reading",
              "id-ID": "Reading",
              "ms-MY": "Reading",
              "pt-BR": "Reading",
              "tr-TR": "Reading",
              "vi-VN": "Reading"
            },
            "icon": "book-open-page-variant",
            "type": "reading"
          },
          {
            "titlei18n": {
              "en-US": "Listening",
              "es-MX": "Listening",
              "fr-FR": "Listening",
              "id-ID": "Listening",
              "ms-MY": "Listening",
              "pt-BR": "Listening",
              "tr-TR": "Listening",
              "vi-VN": "Listening"
            },
            "icon": "ear-hearing",
            "type": "listening"
          }
        ]
      },
      {
        "step": "plan",
        "enabled": true,
        "titlei18n": {
          "en-US": "How much time can you devote to studying each day?",
          "es-MX": "¿Cuánto tiempo puedes dedicar a estudiar cada día?",
          "fr-FR": "Combien de temps pouvez-vous consacrer à l'étude chaque jour ?",
          "id-ID": "Berapa banyak waktu yang dapat Anda luangkan untuk belajar setiap hari?",
          "ms-MY": "Berapa banyak masa yang anda boleh luangkan untuk belajar setiap hari?",
          "pt-BR": "Quanto tempo você pode dedicar aos estudos por dia?",
          "tr-TR": "Her gün çalışmaya ne kadar zaman ayırabilirsiniz?",
          "vi-VN": "Bạn có thể dành bao nhiêu thời gian để học mỗi ngày?"
        },
        "labeli18n": {
          "en-US": "Study plan",
          "es-MX": "Plan de estudio",
          "fr-FR": "Plan d'étude",
          "id-ID": "Rencana belajar",
          "ms-MY": "Pelan pembelajaran",
          "pt-BR": "Plano de estudos",
          "tr-TR": "Çalışma planı",
          "vi-VN": "Kế hoạch học tập"
        },
        "descriptioni18n": {
          "en-US": "We'll personalize your study recommendations based on your exam date and daily study time.",
          "es-MX": "Personalizaremos tus recomendaciones de estudio según tu fecha de examen y tu tiempo de estudio diario.",
          "fr-FR": "Nous personnaliserons vos recommandations d'étude en fonction de votre date d'examen et de votre temps d'étude quotidien.",
          "id-ID": "Kami akan menyesuaikan rekomendasi belajar Anda berdasarkan tanggal ujian dan waktu belajar harian Anda.",
          "ms-MY": "Kami akan menyesuaikan cadangan pembelajaran anda berdasarkan tarikh peperiksaan dan masa pembelajaran harian anda.",
          "pt-BR": "Vamos personalizar suas recomendações de estudo com base na data da sua prova e no tempo de estudo diário.",
          "tr-TR": "Çalışma önerilerinizi sınav tarihinize ve günlük çalışma sürenize göre kişiselleştireceğiz.",
          "vi-VN": "Chúng tôi sẽ cá nhân hóa đề xuất học tập của bạn dựa trên ngày thi và thời gian học hằng ngày."
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "30 minutes",
              "es-MX": "30 minutos",
              "fr-FR": "30 minutes",
              "id-ID": "30 menit",
              "ms-MY": "30 minit",
              "pt-BR": "30 minutos",
              "tr-TR": "30 dakika",
              "vi-VN": "30 phút"
            },
            "icon": "clock-fast",
            "type": "30"
          },
          {
            "titlei18n": {
              "en-US": "60 minutes",
              "es-MX": "60 minutos",
              "fr-FR": "60 minutes",
              "id-ID": "60 menit",
              "ms-MY": "60 minit",
              "pt-BR": "60 minutos",
              "tr-TR": "60 dakika",
              "vi-VN": "60 phút"
            },
            "icon": "clock-star-four-points-outline",
            "type": "60"
          },
          {
            "titlei18n": {
              "en-US": "90 minutes",
              "es-MX": "90 minutos",
              "fr-FR": "90 minutes",
              "id-ID": "90 menit",
              "ms-MY": "90 minit",
              "pt-BR": "90 minutos",
              "tr-TR": "90 dakika",
              "vi-VN": "90 phút"
            },
            "icon": "book-open-blank-variant",
            "type": "90"
          },
          {
            "titlei18n": {
              "en-US": "120 minutes",
              "es-MX": "120 minutos",
              "fr-FR": "120 minutes",
              "id-ID": "120 menit",
              "ms-MY": "120 minit",
              "pt-BR": "120 minutos",
              "tr-TR": "120 dakika",
              "vi-VN": "120 phút"
            },
            "icon": "book-open-page-variant",
            "type": "120"
          }
        ]
      },
      {
        "step": "review",
        "enabled": true,
        "titlei18n": {
          "en-US": "Your personalized study plan is ready.",
          "es-MX": "Tu plan de estudio personalizado está listo.",
          "fr-FR": "Votre plan d'étude personnalisé est prêt.",
          "id-ID": "Rencana belajar personal Anda sudah siap.",
          "ms-MY": "Pelan pembelajaran peribadi anda sudah sedia.",
          "pt-BR": "Seu plano de estudos personalizado está pronto.",
          "tr-TR": "Kişiselleştirilmiş çalışma planınız hazır.",
          "vi-VN": "Kế hoạch học tập cá nhân hóa của bạn đã sẵn sàng."
        },
        "labeli18n": {
          "en-US": "Profile ready",
          "es-MX": "Perfil listo",
          "fr-FR": "Profil prêt",
          "id-ID": "Profil siap",
          "ms-MY": "Profil sedia",
          "pt-BR": "Perfil pronto",
          "tr-TR": "Profil hazır",
          "vi-VN": "Hồ sơ đã sẵn sàng"
        },
        "descriptioni18n": {
          "en-US": "Take a quick diagnostic to discover your level and get personalized recommendations.",
          "es-MX": "Realiza un diagnóstico rápido para descubrir tu nivel y obtener recomendaciones personalizadas.",
          "fr-FR": "Faites un diagnostic rapide pour découvrir votre niveau et obtenir des recommandations personnalisées.",
          "id-ID": "Ikuti diagnostik singkat untuk mengetahui tingkat kemampuan Anda dan mendapatkan rekomendasi yang dipersonalisasi.",
          "ms-MY": "Lakukan diagnostik ringkas untuk mengetahui tahap anda dan dapatkan cadangan yang diperibadikan.",
          "pt-BR": "Faça um diagnóstico rápido para descobrir seu nível e receber recomendações personalizadas.",
          "tr-TR": "Seviyenizi keşfetmek ve kişiselleştirilmiş öneriler almak için hızlı bir tanılama testi yapın.",
          "vi-VN": "Làm bài chẩn đoán nhanh để khám phá trình độ của bạn và nhận đề xuất cá nhân hóa."
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "enableSessionReplay": false,
      "testDriver": "pte",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": true,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      },
      "configOverrides": {
        "proficiencyLabel": "CEFR Level"
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(148, 143, 153)",
          "primary": "rgb(193, 191, 255)",
          "surface": "rgb(20, 18, 24)",
          "backdrop": "rgba(0, 0, 0, 0.6)",
          "tertiary": "rgb(86, 226, 225)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(28, 25, 36)",
            "level2": "rgb(34, 30, 44)",
            "level3": "rgb(40, 35, 52)",
            "level4": "rgb(44, 38, 58)",
            "level5": "rgb(48, 42, 64)"
          },
          "onPrimary": "rgb(32, 0, 102)",
          "onSurface": "rgb(230, 224, 233)",
          "secondary": "rgb(183, 155, 254)",
          "background": "rgb(10, 8, 14)",
          "onTertiary": "rgb(22, 133, 132)",
          "onSecondary": "rgb(41, 0, 102)",
          "onBackground": "rgb(230, 224, 233)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(81, 46, 171)",
          "inverseSurface": "rgb(230, 224, 233)",
          "outlineVariant": "rgb(73, 69, 78)",
          "surfaceVariant": "rgb(44, 41, 48)",
          "surfaceDisabled": "rgba(255, 255, 255, 0.10)",
          "inverseOnSurface": "rgb(50, 47, 53)",
          "onErrorContainer": "rgb(255, 218, 214)",
          "onSurfaceVariant": "rgb(202, 196, 207)",
          "primaryContainer": "rgb(81, 46, 171)",
          "onSurfaceDisabled": "rgba(255, 255, 255, 0.34)",
          "tertiaryContainer": "rgb(34, 199, 198)",
          "onPrimaryContainer": "rgb(255, 255, 255)",
          "secondaryContainer": "rgb(36, 30, 50)",
          "onTertiaryContainer": "rgb(5, 51, 50)",
          "onSecondaryContainer": "rgb(230, 224, 233)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(122, 117, 127)",
          "primary": "rgb(81, 46, 171)",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(13, 0, 77, 0.20)",
          "tertiary": "rgb(34, 199, 198)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(250, 249, 255)",
            "level2": "rgb(246, 245, 253)",
            "level3": "rgb(242, 240, 251)",
            "level4": "rgb(239, 237, 250)",
            "level5": "rgb(236, 234, 248)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(28, 27, 31)",
          "secondary": "rgb(121, 80, 226)",
          "background": "rgb(247, 247, 247)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(28, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(193, 191, 255)",
          "inverseSurface": "rgb(50, 47, 53)",
          "outlineVariant": "rgb(202, 196, 207)",
          "surfaceVariant": "rgb(231, 224, 235)",
          "surfaceDisabled": "rgba(51, 51, 51, 0.12)",
          "inverseOnSurface": "rgb(245, 239, 247)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(73, 69, 78)",
          "primaryContainer": "rgb(13, 0, 77)",
          "onSurfaceDisabled": "rgba(28, 27, 31, 0.50)",
          "tertiaryContainer": "rgb(201, 248, 248)",
          "onPrimaryContainer": "rgb(255, 255, 255)",
          "secondaryContainer": "rgb(248, 242, 250)",
          "onTertiaryContainer": "rgb(5, 51, 50)",
          "onSecondaryContainer": "rgb(28, 27, 31)"
        }
      }
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 06:56:30.246218+00"
  },
  "faa": {
    "id": "faa",
    "tenant": {
      "id": "17b4c5fe-6373-4ae0-989a-8ee2b79c417c",
      "name": "PSI"
    },
    "supportEmail": "support@app.aviation.psiexams.com",
    "companyName": "PSI",
    "app": {
      "id": "16cf7bb8-047a-418d-bfe8-e6b22e46d7b1",
      "name": "PSI Aviation Test Prep",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "aviation.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6745539866"
        },
        "android": {
          "versionCode": 27,
          "package": "com.memorang.psi.aviation",
          "googleServicesJson": "8002a5c0-e8ff-454a-bc1f-7cdde1224ee2",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.aviation",
          "buildNumberState": {
            "currentVersion": "1.0.16",
            "buildNumber": 3
          }
        }
      },
      "version": "1.0.16",
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 16,
        "answer": 16,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "fb3c79e43fdfa23b40bc23fc4e365226"
        }
      },
      "logo": {
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/icon.png",
        "adaptiveIcon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/stacked_app_logo_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/stacked_app_logo_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/app_logo_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.aviation.psiexams.com",
        "privacy": "https://app.aviation.psiexams.com/legal/privacy",
        "tos": "https://app.aviation.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/az/app/psi-aviation-test-prep/id6745539866",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.aviation",
        "redeemSupportUrl": "https://app.aviation.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_DiGjBeJxHsEifBsXveNNGQfVkQq",
          "android": "goog_EJYJzpGCMSnBdgwrrNCQcNwDvzv"
        },
        "oneSignalAppId": "26dc479c-21a6-48e4-9c6f-a51bf569d19c",
        "clerk": {
          "publishableKeyDev": "pk_test_bm92ZWwtc3R1ZC05MC5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmF2aWF0aW9uLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AI Wingman",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/aila.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Aviation Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a Sample test"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/landing.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_Fqut1af9ZyetoVK6cR9EEGPtyMLu",
            "deployedAt": "2026-05-07T16:09:05.542Z",
            "version": "1.0.16"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "diagnosticLabel": {
        "en-US": "free sample test"
      },
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Sample tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      }
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subject mastery",
      "showRedeem": true,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "study-pack-outline",
              "selected": "study-pack"
            },
            "enabled": false,
            "custom": true
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "disclaimer": "The FAA testing system includes supplemental publications containing graphics, legends, and maps essential for accurately answering specific exam questions. These resources can be accessed here: [https://www.faa.gov/training_testing/testing/supplements/media/sport_rec_private_akts.pdf](https://www.faa.gov/training_testing/testing/supplements/media/sport_rec_private_akts.pdf).\n\\\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam.",
      "welcomeDialog": {
        "diagnostic": {
          "title": "Welcome to your {{examName}}.",
          "body": "The sample test questions are not intended to be used as a study guide; they are a representation of the material that will be found on your actual knowledge test. When you take the real test, you’ll see a tutorial walking you through its navigation and functionality. Although you can access and review the questions as much as you desire, it is recommended you allow enough time to complete the sample test in one sitting and free from distractions.\n\\\nThe total time allotted to complete the exam is **{{hr}} hours or {{min}} minutes**, which is an average of **{{sec}} seconds** per question.\n\\\nFeel free to navigate between questions as you work through them. Once you have finished the test, you will receive a score report with an analysis of your results. Be sure to click on “Review Answers” where you can go question-by-question with additional explanations and help. Good luck!\n\\\n**Disclaimer:**\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam."
        },
        "disclaimer": "**Disclaimer:**\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam."
      },
      "testDriver": "default",
      "showFlightCalculator": true,
      "allowMarking": true,
      "showCrossOut": true,
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(138, 146, 150)",
          "primary": "rgb(164, 205, 222)",
          "surface": "rgb(25, 28, 29)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(192, 207, 103)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(28, 37, 40)",
            "level2": "rgb(30, 43, 47)",
            "level3": "rgb(32, 48, 54)",
            "level4": "rgb(33, 50, 56)",
            "level5": "rgb(35, 54, 60)"
          },
          "onPrimary": "rgb(4, 53, 67)",
          "onSurface": "rgb(225, 227, 228)",
          "secondary": "rgb(255, 181, 152)",
          "background": "rgb(12, 15, 16)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "rgb(89, 28, 0)",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(16, 61, 75)",
          "inverseSurface": "rgb(225, 227, 228)",
          "outlineVariant": "rgb(64, 72, 76)",
          "surfaceVariant": "rgb(64, 72, 76)",
          "surfaceDisabled": "rgba(225, 227, 228, 0.12)",
          "inverseOnSurface": "rgb(46, 49, 50)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(191, 200, 204)",
          "primaryContainer": "rgb(34, 76, 90)",
          "onSurfaceDisabled": "rgba(225, 227, 228, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(191, 233, 251)",
          "secondaryContainer": "rgb(126, 44, 0)",
          "onTertiaryContainer": "rgb(220, 235, 128)",
          "onSecondaryContainer": "rgb(255, 219, 206)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "rgb(16, 61, 75)",
          "surface": "rgb(251, 252, 254)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "rgb(188, 82, 33)",
          "background": "rgb(239, 241, 242)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(164, 205, 222)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(191, 233, 251)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(220, 235, 128)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "rgb(255, 219, 206)",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "rgb(55, 14, 0)"
        }
      },
      "roundness": 0
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 13:51:18.690949+00"
  }
} as unknown as ConfigMap;